import { CurrencyPipe, DatePipe } from "@angular/common";
import { SplitInterpolation, ThrowStmt } from "@angular/compiler";
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild, ViewChildren, HostListener, TemplateRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { errorMonitor } from "events";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { element } from "protractor";
import { Observable, Subscription, of, zip } from "rxjs";
import { catchError, first, map, switchMap, tap } from "rxjs/operators";
import { DteEmitido } from "src/app/models/Dte/DteEmitido";
import { DteFilter } from "src/app/models/Dte/DteFilter";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { TipoDte } from "src/app/models/tipoDte";
import { Traza } from "src/app/models/Traza";
import { DteEmitidosService } from "src/app/services/dte-emitidos.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import { ConfigMantenedorDTE } from "./config-mantenedor-dte";
import * as FileSaver from "file-saver";
import { AbstractControl, FormBuilder, FormControl, FormGroup, NgForm, Validators } from "@angular/forms";
import { FormrulesConfigService } from "src/app/shared/configuration/formrules-config.service";
import { MultipleEmailValidator } from "src/app/directives/multi-email.directive";
import { NotaCredito } from "src/app/models/NotaCredito";
import { DetalleDte } from "src/app/models/Dte/DetalleDte";
import Swal, { SweetAlertIcon } from "sweetalert2";
import { Response } from "src/app/shared/models/Response";
import * as JSZip from "jszip";
import { SameWordEmailValidator } from "src/app/directives/same-word-email.directive";
import { PermissionService } from "src/app/services/permission.service";
import { InvoiceType } from "src/app/models/Dte/invoiceType.enum";
import { NotaDebito } from "src/app/models/NotaDebito";
import { IDte } from "src/app/models/Dte/IDte";
import { EmisorService } from "src/app/services/emisor.service";
import { SessionUser } from "src/app/shared/models/sessionUser";
import { CesionRequest } from "src/app/models/Cesion/CesionRequest";
import { ReferenciaDte } from "src/app/models/Dte/ReferenciaDte";
import { ConsoleDevService } from "src/app/services/console-service.service";
import { SortType } from "@swimlane/ngx-datatable";
import { ActualizarEstadoSiiRequest } from "src/app/models/Dte/ActualizarEstadoSiiRequest";
import { ReenvioEmailRequest } from "src/app/models/Dte/ReenvioEmailRequest";
import { Conciliacion, ImportacionBoletasSiiStatus, ImportacionBoletasSiiTotales } from "src/app/models/Dte/Conciliacion";
import * as moment from "moment";
import { ReutilizacionMasivaRequest } from "src/app/models/Dte/ReutilzacionMasivaRequest";
import { FacturadorMasivoService } from "src/app/services/facturador-masivo.service";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { SendInvoiceRequest } from "src/app/models/CorreoEnvio/SendInvoiceRequest";
import { SendInvoicemasiveRequest } from "src/app/models/CorreoEnvio/SendInvoiceMasiveRequest";
import { CorreoEnvioService } from "src/app/services/CorreoEnvio.service";
import { PersonasAutorizadasService } from "../../../services/paseronas-autorizadas.service";
import { VerificacionCertificadoService } from "src/app/services/verificacion-certificado.service";
import { ClienteService } from "src/app/services/cliente.service";
import { ExportModalComponent } from "../../layout/export-modal/export-modal.component";
import { SessionUserService } from "src/app/modules/auth/session-user/session-user.service";
import { MarcarPagadoOPendiente } from "src/app/models/MarcarPagadoOPendiente";
import { PaykuService } from "src/app/services/payku.service";
import { ResultadoDescargaMasiva } from "src/app/models/Dte/ResultadoDescargaMasiva";
import { DteExportSummary } from "src/app/models/Dte/DteExportSummary";
import { Receptor } from "src/app/models/Receptor/Receptor";
import { esRutGenerico } from "src/app/models/Receptor/receptor-personalizacion";

@Component({
	selector: "app-mantenedor-dte-emitidos",
	templateUrl: "./mantenedor-dte-emitidos.component.html",
	styleUrls: ["./mantenedor-dte-emitidos.component.scss"],
})
export class MantenedorDteEmitidosComponent implements OnInit, AfterViewInit {
	SortType = SortType;
	public tracesModal: NgbModalRef;
	public anuladorModal: NgbModalRef;
	public senderDteModal: NgbModalRef;
	public detailModal: NgbModalRef;
	private cesionDteModal: NgbModalRef;
	loading: boolean = false;

	public dateConciliacion: any = { startDate: null, endDate: null, minDate: null };
	public validDate: boolean = true;
	private modalImportedDteSii: NgbModalRef;
	private modalImportBoletasSii: NgbModalRef;
	public dateImportacionBoletas: any = { startDate: null, endDate: null };
	public validDateImportacionBoletas: boolean = true;
	public importacionBoletasStatus: ImportacionBoletasSiiStatus;
	public importacionBoletasLoading: boolean = false;
	private importacionBoletasStatusRequestId: number = 0;
	public todayString = moment();
	public fechaInicioDefault: Date;
	public fechaFinDefault: Date;
	// public minDate = moment().subtract(5, 'months').startOf('month');
	public minDate = null;
	public cantidadDTE: number;
	public maxDTE: number;
	locale = {
		daysOfWeek: moment.weekdaysMin(),
		monthNames: moment.monthsShort(),
		firstDay: moment.localeData().firstDayOfWeek(),
		applyLabel: "ok",
		clearLabel: "Limpiar",
		format: "MM/YYYY",
	};
	localeBoletas = {
		daysOfWeek: moment.weekdaysMin(),
		monthNames: moment.monthsShort(),
		firstDay: moment.localeData().firstDayOfWeek(),
		applyLabel: "ok",
		clearLabel: "Limpiar",
		format: "MM/YYYY",
	};
	public configLocal = ConfigMantenedorDTE;
	public rowsMantenedor: DteEmitido[] = [];
	public selected: DteEmitido[] = []; //dtes seleccionados por checkbox
	public selectedItem: DteEmitido; //dte seleccionado para envio individual y despliegue en modal
	public selectedAllItemsInPage: any = {}; // bool para la seleccion total de elementos en tabla
	public searchRows: any[] = [];
	public searchCriteria;
	fileIdState: Observable<object>;
	fileIdValue: string;
	registrationIdValue: string;
	receptorRutString: string;
	public configScroll: PerfectScrollbarConfigInterface = {};
	public emisorId: string;
	public usuarioId: string;
	public sucursalId: string;
	public empresasSource: Emisor[];
	public tipoDteSource: TipoDte[];
	public page = new Page();
	public filter = new DteFilter();
	public tracesToShow: Traza[] = [];
	public dteToShow: DteEmitido = new DteEmitido();
	public dteToNullify: DteEmitido = new DteEmitido();
	public dteToNullifyReferences: IDte[] = [];
	public senderForm: FormGroup;
	@ViewChild("currentSwal") private currentSwal: SwalComponent;
	@ViewChild("notesSwal") private notesSwal: SwalComponent;
	@ViewChild("tableMobile") tableRef: any;
	@ViewChild("table") table: any;
	@ViewChild("referenciaModal") referenciaModal: TemplateRef<any>;
	@ViewChild("imagenModal") imagenModal: TemplateRef<any>;
	private closeActionsHandler: any;
	public filterDescription: string;

	// Propiedades para paginación del modal de envío masivo
	public modalCurrentPage: number = 1;
	public modalItemsPerPage: number = 5;
	public modalTotalItems: number = 0;
	public nombreTipoNota: string = "Anulación";
	expanded: any = {};

	private invoiceType$: Observable<InvoiceType>;
	public notaType: number;
	public nombreDte: string;
	public componentStarted: boolean = false;
	public isSuperAdmin: boolean = this.tokenService.getUser().superAdmin;
	public showMarcarPagadoButton: boolean = false;
	public tienePayku = false;
	showInfoModal = false;
	constructor(
		public activatedRoute: ActivatedRoute,
		private dteService: DteEmitidosService,
		private facturadorService: FacturadorMasivoService,
		private ref: ChangeDetectorRef,
		private tokenService: TokenStorageService,
		private localStorage: LocalStorageService,
		public utilities: UtilitiesService,
		private modalService: NgbModal,
		private datePipe: DatePipe,
		private currencyPipe: CurrencyPipe,
		private formBuilder: FormBuilder,
		private personasAutorizadasService: PersonasAutorizadasService,
		private formConfig: FormrulesConfigService,
		public permissions: PermissionService,
		private router: Router,
		private emisorService: EmisorService,
		private correoEnvioService: CorreoEnvioService,
		private logService: ConsoleDevService,
		public planUsuarioService: PlanUsuarioService,
		private validadorCertificadoService: VerificacionCertificadoService,
		private clienteService: ClienteService,
		private sessionUserService: SessionUserService,
		private paykuService: PaykuService
	) {
		this.emisorId = this.tokenService.getCompany();
		this.usuarioId = (this.tokenService.getUser() as SessionUser).id;
		this.sucursalId = this.tokenService.getSubsidiary();
		this.filter.importacionMasivaId = "";

		this.empresasSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		if (this.isSuperAdmin) {
			this.getEmisoresFullList();
		}

		this.tipoDteSource = JSON.parse(this.localStorage.getDteTypes()) as TipoDte[];
		this.filter.emisorId = this.emisorId;
		this.filter.sucursalId = this.sucursalId;
		this.setDefaultSearchDateRange();
		this.checkStateId();
		this.starterPage();
		if (this.fileIdState) {
			this.getFileIdInState();
		}
		this.filter.tipoDteId = [];
		this.filter.reutilizado = false;
		this.createSenderForm();
	}

	private setDefaultSearchDateRange() {
		const fechaInicio = moment().startOf("month").subtract(5, "months");
		const fechaFin = moment().endOf("month");

		this.fechaInicioDefault = fechaInicio.toDate();
		this.fechaFinDefault = fechaFin.toDate();
		this.filter.fechaDesde = fechaInicio.clone().utcOffset(0, true).startOf("day").toISOString() as any;
		this.filter.fechaHasta = fechaFin.clone().utcOffset(0, true).endOf("day").toISOString() as any;
	}

	private syncSearchDateRangeFromFilter() {
		if (!this.filter.fechaDesde || !this.filter.fechaHasta) {
			return;
		}
		const fechaInicio = moment(this.filter.fechaDesde);
		const fechaFin = moment(this.filter.fechaHasta);
		if (!fechaInicio.isValid() || !fechaFin.isValid()) {
			return;
		}
		this.fechaInicioDefault = fechaInicio.toDate();
		this.fechaFinDefault = fechaFin.toDate();
	}
	esPendienteCobranza(row: DteEmitido): boolean {
		return (row as any).dtePagado == false; // heurística
	}
	reenviarLinkPago(row: DteEmitido) {
		//limpiar detalleDte dte emitido
		this.loading = true;
		this.dteService.reenviarLinkPayku([row]).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				const ok = res?.data === true;
				const icon: SweetAlertIcon = ok ? "success" : "warning";
				const errors = res?.errors && res.errors.length ? this.utilities.setErrorMessageFromArray({ errors: res.errors }) : "";
				Swal.fire({ icon, title: "Reenvío de Cobranza", html: `${res.message}${!ok && errors ? "<br/>" + errors : ""}` });
			},
			(err) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({ icon: "error", title: "Error en Reenvío", text: this.utilities.setErrorMessageFromArray(err.error) });
			}
		);
	}
	openInfoModal() {
		this.showInfoModal = true;
	}

	closeInfoModal() {
		this.showInfoModal = false;
	}

	get mostrarBotonMasivoCobranza(): boolean {
		if (!this.selected || this.selected.length === 0) return false;
		return this.selected.some((r) => this.esPendienteCobranza(r));
	}

	reenviarLinkPagoMasivo() {
		const candidatos = (this.selected || []).filter((r) => this.esPendienteCobranza(r));
		if (candidatos.length === 0) {
			Swal.fire({ icon: "error", title: "Sin documentos válidos", text: "Seleccione DTEs pendientes." });
			return;
		}
		this.loading = true;
		this.dteService.reenviarLinkPayku(candidatos).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				const ok = res?.data === true;
				const icon: SweetAlertIcon = ok ? "success" : "warning";
				const errors = res?.errors && res.errors.length ? this.utilities.setErrorMessageFromArray({ errors: res.errors }) : "";
				Swal.fire({ icon, title: "Envío Masivo Cobranza", html: `${res.message}${!ok && errors ? "<br/>" + errors : ""}` });
			},
			(err) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({ icon: "error", title: "Error en Envío Masivo", text: this.utilities.setErrorMessageFromArray(err.error) });
			}
		);
	}

	tryEnviarCobranzaMasivoConfirm() {
		if (this.selected.length > 0) {
			const validos = this.selected.filter((x) => this.esPendienteCobranza(x));
			if (validos.length === 0) {
				Swal.fire({ icon: "error", title: "Error de Selección", text: "Solo se puede enviar cobranza a documentos Pendientes." });
				return;
			}
			Swal.fire({
				icon: "info",
				title: "Enviar Cobranza",
				text: `¿Desea enviar la cobranza a ${validos.length} documento(s) seleccionado(s)?`,
				confirmButtonText: "Continuar",
				confirmButtonColor: "#1BC5BD",
				showCancelButton: true,
				cancelButtonText: "Cancelar",
				cancelButtonColor: "#F64E60",
			}).then((res) => {
				if (res.isConfirmed) {
					this.reenviarLinkPagoMasivo();
				}
			});
		} else {
			Swal.fire({ icon: "error", title: "Error de Selección", text: "No hay documentos seleccionados. Use la columna seleccionadora." });
		}
	}
	// --- FIN NUEVA LÓGICA COBRANZA ---

	abrirModalReferencia(type: number): void {
		this.notaType = type;

		if (type === 6) {
			this.nombreDte = "Débito";
		} else {
			this.nombreDte = "Crédito";
		}

		this.modalService.open(this.referenciaModal, { centered: true });
	}

	opcionSimpleFactura(modal: any): void {
		modal.close();
		this.modalService.open(this.imagenModal, { centered: true });
	}

	opcionOtroProveedor(modal: any): void {
		modal.close();
		this.navigateToFacturador(this.notaType);
	}

	toggleActions(row: any): void {
		const newState = !row.showActions;
		this.rowsMantenedor.forEach((r) => {
			if (r !== row && r.showActions) {
				r.showActions = false;
				document.removeEventListener("click", this.closeActionsHandler);
			}
		});

		row.showActions = newState;

		if (newState) {
			this.closeActionsHandler = this.closeActionsMenu.bind(this, row);
			setTimeout(() => document.addEventListener("click", this.closeActionsHandler), 0);
		} else {
			document.removeEventListener("click", this.closeActionsHandler);
		}
	}

	closeActionsMenu(row: any, event: MouseEvent): void {
		if (!(event.target as HTMLElement).closest(".action-container")) {
			row.showActions = false;
			this.ref.detectChanges();
			document.removeEventListener("click", this.closeActionsHandler);
		}
	}

	public getTotalPages(rowCount: number, pageSize: number): number {
		if (!pageSize) {
			return 1;
		}
		return Math.ceil(rowCount / pageSize);
	}

	ngOnInit(): void {
		this.sessionUserService.verificarSesionUsuario();
		this.validatePaykuAdicional();
		this.activatedRoute.paramMap.subscribe(() => { });

		this.emisorId = this.tokenService.getCompany();
		let sessionEmisor = this.empresasSource.find((emisor) => emisor.emisorId == this.emisorId);
		this.filter.ambienteId = sessionEmisor.ambiente;
		this.planUsuarioService.getCurrentDocuments(sessionEmisor.planUsuarioId).subscribe((resp) => {
			this.maxDTE = resp.maxdtes;
			this.cantidadDTE = resp.dtes;
			this.ref.detectChanges();
		});
		this.validarCertificado();
	}
	ngAfterViewInit(): void { }
	checkStateId() {
		this.fileIdState = this.activatedRoute.paramMap.pipe(
			map(() => {
				return window.history.state;
			})
		);
	}
	getFileIdInState() {
		this.loading = true;
		this.fileIdState
			.subscribe((result) => {
				this.fileIdValue = result["paramId"];
				if (this.fileIdValue) {
					this.filter.importacionMasivaId = this.fileIdValue ? this.fileIdValue : "";
				}
				this.receptorRutString = result["receptorRut"];
				this.filterDescription = result["filterDescription"];
				let emisorImportado = result["filterEmisor"];
				let sucursalImportado = result["filterSucursal"];
				this.filter.emisorId = emisorImportado ? emisorImportado : this.emisorId;
				this.filter.sucursalId = sucursalImportado ? sucursalImportado : this.sucursalId;
				this.filter.rutReceptor = this.receptorRutString ? this.receptorRutString : "";
				this.filter.clienteId = result["clienteId"];
				let fechaDesde = result["fechaDesde"];
				let fechaHasta = result["fechaHasta"];
				if (fechaDesde && fechaHasta) {
					this.filter.fechaDesde = fechaDesde;
					this.filter.fechaHasta = fechaHasta;
					this.syncSearchDateRangeFromFilter();
				}
				let fechaEmision = result["date"];
				if (fechaEmision) {
					this.filter.fechaDesde = fechaEmision;
					this.filter.fechaHasta = fechaEmision;
					this.syncSearchDateRangeFromFilter();
				}

				let codigoSii = result["codigoSii"];
				if (codigoSii) {
					this.filter.codigoSii = codigoSii;
				}

				let nulo = result["nulos"];
				if (nulo != undefined) {
					this.filter.nulos = nulo;
				}

				// Filtro por folio (agregado para Payku)
				let folio = result["folio"];
				if (folio) {
					this.filter.folio = folio;
					if (!sucursalImportado) {
						this.filter.sucursalId = "";
					}
				}

				this.loading = false;
			})
			.add(() => {
				this.loading = false;
			});
	}

	private async validarCertificado() {
		const validacionCertificado = await this.validadorCertificadoService.validar();
		if (validacionCertificado) {
			this.setPage({ offset: 0 });
		}
	}

	downloadFile() { }
	detailOpenModal(modalRef, row: DteEmitido) {
		this.dteToShow = row;
		this.loading = true;
		if (row.codigoTipoDte == 46) {
			this.dteService
				.getProveedorDte(row.dteId)
				.subscribe(
					(res) => {
						this.dteToShow.proveedor = res.data;
					},
					(err) => {
						this.setSwalAndFire(this.currentSwal, "error", "Error al obtener detalles", "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error));
					}
				)
				.add(() => {
					this.dteService
						.getDetalleDte(row.dteId)
						.subscribe(
							(res) => {
								this.dteToShow.detalleDte = res.data;
							},
							(err) => {
								this.setSwalAndFire(this.currentSwal, "error", "Error al obtener detalles", "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error));
							}
						)
						.add(() => {
							this.loading = false;
							this.ref.detectChanges();
							this.detailModal = this.modalService.open(modalRef, {
								windowClass: "",
								size: "lg",
								centered: true,
							});
						});
				});
		} else if (row.codigoTipoDte == 43) {
			this.dteService
				.getReceptorDteLiquidacion(row.dteId)
				.subscribe(
					(res) => {
						this.dteToShow.receptorAsociado = res.data;
					},
					(err) => {
						this.setSwalAndFire(this.currentSwal, "error", "Error al obtener detalles", "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error));
					}
				)
				.add(() => {
					if (row.importado) {
						this.dteToShow.detalleDte = [];
						return;
					}

					this.dteService.getDetalleDte(row.dteId).subscribe(
						(res) => {
							this.dteToShow.detalleDte = res.data;
						},
						(err) => {
							this.setSwalAndFire(this.currentSwal, "error", "Error al obtener detalles", "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error));
						}
					);
				})
				.add(() => {
					this.dteService
						.getComisionesDte(row.dteId)
						.subscribe(
							(res) => {
								this.dteToShow.comisionesCargosDte = res.data;
								this.dteToShow.comisionCargo = 0;
								this.dteToShow.comisionesCargosDte.forEach((detalle) => {
									this.dteToShow.comisionCargo += detalle.total;
								});
							},
							(err) => {
								this.setSwalAndFire(this.currentSwal, "error", "Error al obtener comisiones", "No fue posible obtener las comisiones del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error));
							}
						)
						.add(() => {
							this.loading = false;
							this.ref.detectChanges();
							this.detailModal = this.modalService.open(modalRef, {
								windowClass: "",
								size: "lg",
								centered: true,
							});
						});
				});
		} else if (row.codigoTipoDte == 56 || row.codigoTipoDte == 61) {
			//calling dte references for shiwing its details
			let receptorTemporal: any = null;
			this.dteService
				.getReferenciasDte(row.dteId)
				.subscribe(
					(result) => {
						let dteReferences = result.data as ReferenciaDte[];
						dteReferences.forEach((ref) => {
							if (ref.dte) {
								this.setEmisorToElement(ref.dte);
								this.setTipoDteToElement(ref.dte);
							}
						});
						row.listaReferencias = dteReferences;
						this.logService.log(row.listaReferencias, result.data);
					},
					(error) => {
						this.setSwalAndFire(this.currentSwal, "error", "Error al obtener detalles", "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(error.error));
					}
				)
				.add(() => {
					this.dteService
						.getReceptorDte(row.dteId)
						.subscribe(
							(res) => {
								receptorTemporal = res.data;
							},
							(err) => {
								this.setSwalAndFire(this.currentSwal, "error", "Error al obtener detalles", "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error));
							}
						)
						.add(() => {
							if (row.importado) {
								this.dteToShow.detalleDte = [];
								return;
							}

							this.dteService.getDetalleDte(row.dteId).subscribe(
								(res) => {
									this.dteToShow.detalleDte = res.data;
								},
								(err) => {
									this.setSwalAndFire(this.currentSwal, "error", "Error al obtener detalles", "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(err.error));
								}
							);
						})
						.add(() => {
							this.dteService
								.getInfoDetalleDte(row.dteId)
								.subscribe(
									(result) => {
										this.dteToShow.observaciones = result.dteEmitido.observaciones;
										this.dteToShow.receptorAsociado = receptorTemporal;
										this.dteToShow.impuestos = this.dteToShow.detalleDte.reduce((suma, detalle) => (suma += detalle.totalImpuestosAdicionales), 0);
										this.ref.detectChanges();
									},
									(error) => {
										this.loading = false;
										this.ref.detectChanges();
										this.setSwalAndFire(this.currentSwal, "error", "Error al obtener detalles", "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(error.error));
									}
								)
								.add(() => {
									this.loading = false;
									this.ref.detectChanges();
									this.detailModal = this.modalService.open(modalRef, {
										windowClass: "",
										size: "lg",
										centered: true,
									});
								});
						});
				});
		} else {
			this.dteService
				.getInfoDetalleDte(row.dteId)
				.subscribe(
					(result) => {
						//this.dteToShow = result.dteEmitido;
						this.dteToShow.receptorAsociado = result.receptor;
						this.dteToShow.importado = result.dteEmitido.importado;

						//this.dteToShow.descuentoGlobal = result.descuentoRecargos != null && result.descuentoRecargos.length > 0 ? result.descuentoRecargos[0].valor : undefined;
						this.dteToShow.receptorAsociado.razonSocial = result.receptor.razonSocial;
						this.dteToShow.receptorAsociado.rutString = result.receptor.rutString;
						this.dteToShow.detalleDte = result.detalleDtes as DetalleDte[];
						this.dteToShow.impuestos = this.dteToShow.detalleDte.reduce((suma, detalle) => (suma += detalle.totalImpuestosAdicionales), 0);
						//this.dteToShow = { ...this.dteToShow } as DteEmitido;
						this.ref.detectChanges();
					},
					(error) => {
						this.loading = false;
						this.ref.detectChanges();
						this.setSwalAndFire(this.currentSwal, "error", "Error al obtener detalles", "No fue posible obtener los detalles del documento indicado, intente mas tarde o comuniquese con su administrador" + this.utilities.setErrorMessageFromArray(error.error));
					}
				)
				.add(() => {
					this.loading = false;
					this.ref.detectChanges();
					this.detailModal = this.modalService.open(modalRef, {
						windowClass: "",
						size: "lg",
						centered: true,
					});
				});
		}
	}

	// checkBoletaForImpuestos(dte: DteEmitido): number | undefined {
	// 	//check if the total value of Boleta is greater than the sum of his details and tax, if not get the difference as others taxes(impuestos)
	// 	if (dte.impuestos != undefined) {
	// 		return dte.impuestos;
	// 	} else {
	// 		return undefined;
	// 	}
	// }

	searchElements(emisorId: string) {
		this.loading = true;
		this.dteService.getDataByPage(this.filter, this.page).subscribe(
			(result) => {
				let elements = result.data as DteEmitido[];
				elements.forEach((row) => {
					this.setEmisorToElement(row);
					this.setTipoDteToElement(row);
				});
				this.rowsMantenedor = [...elements];
			},
			(error) => { },
			() => {
				this.loading = false;
				this.ref.detectChanges();
			}
		);
	}

	ngOnDestroy() {
		this.fileIdState = undefined;
	}

	changeSearchedRows(data) {
		if (data != null) {
			this.rowsMantenedor = data;
		}
	}

	onSelect({ selected }) {
		this.selected.splice(0, this.selected.length);
		this.selected.push(...selected);
	}

	getId(row) {
		return row.dteId;
	}

	selectAll(event) {
		if (!this.selectedAllItemsInPage[this.page.pageNumber]) {
			if (this.selected.length > 0) {
				this.rowsMantenedor.map((dte) => {
					this.selected = this.selected.filter((selectedDte) => selectedDte.dteId !== dte.dteId);
				});
			}
			this.selected.push(...this.rowsMantenedor);
			this.selected = [...this.selected];
			this.selectedAllItemsInPage[this.page.pageNumber] = true;
		} else {
			this.rowsMantenedor.map((dte) => {
				this.selected = this.selected.filter((selectedDte) => selectedDte.dteId !== dte.dteId);
			});
			this.selectedAllItemsInPage[this.page.pageNumber] = false;
		}
	}

	setEmisorToElement(row: IDte) {
		if (row.emisorId) {
			let empresaAsociada = this.empresasSource.find((Emisor) => Emisor.emisorId == row.emisorId);
			row.emisorAsociado = empresaAsociada;
		}
	}

	setTipoDteToElement(row: IDte) {
		if (row.tipoDteId) {
			let tipoDteAsociado = this.tipoDteSource.find((tipo) => tipo.tipoDteId == row.tipoDteId);
			row.nombreTipoDte = tipoDteAsociado.abreviacion;
		}
	}

	starterPage() {
		this.page.pageNumber = 0;
		this.page.pageSize = 10;
		this.selectedAllItemsInPage[this.page.pageNumber] = false;
	}
	setPageSize() {
		//this.page.currentPageSize = this.page.page
		this.setPage({ offset: 0 });
	}
	searchElementsByFilter(event) {
		//se toman los valores del filtro que necesite el endpoint de filtro para dte
		this.filter = this.filterConcordance(this.configLocal.barraBusqueda.criteriosKeys, this.filter, event);
		this.filter.tipoDteId = event.tipoDteId != null ? event.tipoDteId : [];
		this.filter.fechaDesde = event.fechaInicio;
		this.filter.fechaHasta = event.fechaFin;
		this.filter.importado = event.importado != null ? (event.importado ? true : false) : null;
		this.filter.reutilizado = event.reutilizado ? true : false;
		this.filter.estadoAcuse = event.estadoAcuseEmitido;
		this.filter[event.criterio] = event.busqueda;
		this.filter = this.utilities.clearOtherFilterCriterias(event.criterio, this.filter, this.configLocal);
		this.filter.estadoSii = event.estadoDte;
		this.filter.sucursalId = event.sucursalId ? event.sucursalId : this.sucursalId;
		this.filter.emisorId = event.emisorId ? event.emisorId : this.emisorId;
		this.filter.nulos = event.nulos == null ? null : event.nulos;
		this.filter.puedenCederse = event.puedenCederse == null ? null : event.puedenCederse;
		if (this.filter.puedenCederse === true && this.filter.importado !== true) {
			this.filter.importado = false;
		}
		this.filter.ambienteId = event.ambienteId ?? this.filter.ambienteId;
		// El search bar emite 'estadoPago' (TriState mapeado a boolean/null). Ajustamos para que se envíe como dtePagado solo para emitidos.
		this.filter.pendientePago = event.pendientePago == null ? null : event.pendientePago;
		this.setPage({ offset: 0 });
	}

	filterConcordance(configCriterias, dteFilter: DteFilter, eventFilter): DteFilter {
		//vaciar del dteFilter aquellos campos distinto al presnetado en el eventFilter actual, segun el arreglo configCriterias
		configCriterias.forEach((criteria) => {
			if (criteria != eventFilter.criterio) {
				dteFilter[criteria] = "";
			}
		});
		return dteFilter;
	}

	setPage(pageInfo) {
		this.loading = true;
		this.page.pageNumber = pageInfo.offset;
		let localPage = JSON.parse(JSON.stringify(this.page));
		localPage.pageNumber += 1;
		if (this.fileIdValue && this.filter.importacionMasivaId) {
			//llamada con fileIdValue al endpoint de lista paginada
			this.dteService
				.getDataByPage(this.filter, localPage)
				.subscribe(
					(pagedData) => {
						let elements = pagedData.data as DteEmitido[];
						this.ref.detectChanges();
						elements.forEach((row) => {
							this.setEmisorToElement(row);
							this.setTipoDteToElement(row);
						});
						this.rowsMantenedor = [...elements];

						this.ref.detectChanges();
						this.setPagefromResponse(this.page, pagedData);
						this.loading = false;
						this.componentStarted = true;
						this.ref.detectChanges();
					},
					(error) => {
						this.currentSwal.icon = "error";
						this.currentSwal.title = "Error en la solicitud";
						this.currentSwal.text = this.utilities.setErrorMessageFromArray(error.error);
						this.currentSwal.fire();
					},
					() => {
						this.loading = false;
						this.ref.detectChanges();
					}
				)
				.add(() => {
					this.loading = false;
					this.ref.detectChanges();
				});
		} else {
			//llamada generica a los dte paginados
			this.dteService
				.getDataByPage(this.filter, localPage)
				.subscribe(
					(pagedData) => {
						let elements = pagedData.data as DteEmitido[];
						this.ref.detectChanges();
						elements.forEach((row) => {
							this.setEmisorToElement(row);
							this.setTipoDteToElement(row);
						});
						this.rowsMantenedor = [...elements];
						this.componentStarted = true;
						this.ref.detectChanges();
						this.setPagefromResponse(this.page, pagedData);
					},
					(error) => {
						this.currentSwal.icon = "error";
						this.currentSwal.title = "Error en la solicitud";
						this.currentSwal.text = this.utilities.setErrorMessageFromArray(error.error);
						this.currentSwal.fire();
					},
					() => {
						this.loading = false;
						this.ref.detectChanges();
					}
				)
				.add(() => {
					this.loading = false;
					this.ref.detectChanges();
				});
		}
	}

	refreshCurrentPage() {
		this.setPage({ offset: this.page.pageNumber ?? 0 });
	}

	setPagefromResponse(currentPage: Page, data: PagedResponse<DteEmitido>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	downloadXml(dte: DteEmitido) {
		this.dteService.getXml(dte.dteId).subscribe(
			(result) => {
				this.loading = true;
				let b64Response = result.data.xml;
				const blobXml = this.utilities.convertB64ToBlob(b64Response, "text/xml");
				FileSaver.saveAs(blobXml, dte.folio + "_" + "dte.xml");
				this.loading = false;
			},
			(error) => {
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error en XML";
				this.currentSwal.text = this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.fire();
				this.loading = false;
			},
			() => {
				this.loading = false;
			}
		);
	}

	regenerarPDF(dte: DteEmitido) {
		this.loading = true;
		this.dteService.regenerarPdf(dte.dteId).subscribe(
			(result) => {
				this.responseToPdfDownload(result.data, dte);
				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error al descargar pdf";
				this.currentSwal.text = "No se pudo generar el documento, intente mas tarde." + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.fire();
			}
		);
	}

	downloadPDF(dte: DteEmitido) {
		this.loading = true;
		if (dte.codigoTipoDte == 43) {
			this.dteService.getPdfLiquidacion(dte.dteId).subscribe(
				(result) => {
					this.responseToPdfDownload(result.data, dte);
					this.loading = false;
					this.ref.detectChanges();
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					this.currentSwal.icon = "error";
					this.currentSwal.title = "Error al descargar pdf";
					this.currentSwal.text = "No se pudo generar el documento, intente mas tarde." + this.utilities.setErrorMessageFromArray(error.error);
					this.currentSwal.fire();
				}
			);
		} else {
			this.dteService.getPdf(dte.dteId).subscribe(
				(result) => {
					this.responseToPdfDownload(result.data, dte);
					this.loading = false;
					this.ref.detectChanges();
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					this.currentSwal.icon = "error";
					this.currentSwal.title = "Error al descargar pdf";
					this.currentSwal.text = "No se pudo generar el documento, intente mas tarde." + this.utilities.setErrorMessageFromArray(error.error);
					this.currentSwal.fire();
				}
			);
		}
	}
	downloadPDFCedible(dte: DteEmitido, cedible: boolean) {
		this.loading = true;
		this.dteService.getPdfCedible(dte.dteId, cedible).subscribe(
			(result) => {
				this.responseToPdfDownload(result.data, dte);
				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error al descargar pdf cedible";
				this.currentSwal.text = "No se pudo generar el documento, intente mas tarde." + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.fire();
			}
		);
	}

	multipleDocumentDownload(fileType) {
		if (this.selected.length > 0) {
			this.loading = true;
			let dteIds = this.selected.map((dte) => dte.dteId);

			if (fileType === "xml") {
				this.getDownloadFilesObservableConResultado(dteIds, fileType).subscribe(
					(response) => {
						const downloadResult = response?.data;
						if (!downloadResult?.archivoBase64) {
							this.currentSwal.icon = "error";
							this.currentSwal.title = "Error en exportación";
							this.currentSwal.text = "No fue posible procesar el archivo ZIP de la descarga.";
							this.currentSwal.fire();
							return;
						}

						const blob = this.utilities.convertB64ToBlob(downloadResult.archivoBase64, "application/zip");
						const dateOfDownLoad = this.datePipe.transform(Date.now(), "dd/MM/yyyy");
						const fileName = downloadResult.nombreArchivo
							? downloadResult.nombreArchivo
							: `documentos_${dateOfDownLoad}_${fileType}.zip`;
						FileSaver.saveAs(blob, fileName);
						this.mostrarResultadoDescargaMasiva(downloadResult);
					},
					(err) => {
						this.manejarErrorDescargaMasiva(err);
					},
					() => {
						this.loading = false;
						this.ref.detectChanges();
					}
				);
				return;
			}

			this.getDownloadFilesObservable(dteIds, fileType).subscribe(
				(response) => {
					const blob = new Blob([response], { type: "application/zip" });
					const dateOfDownLoad = this.datePipe.transform(Date.now(), "dd/MM/yyyy");
					FileSaver.saveAs(blob, `documentos_${dateOfDownLoad}_${fileType}.zip`);

					this.currentSwal.icon = "success";
					this.currentSwal.title = "Descarga de documentos";
					this.currentSwal.text = "Los documentos seleccionados se han descargado";
					this.currentSwal.fire();
				},
				(err) => {
					this.loading = false;
					this.ref.detectChanges();
					console.log(err);
					this.currentSwal.icon = "error";
					this.currentSwal.title = "Error en exportación";
					this.currentSwal.text = "No ha sido posible descargar los documentos seleccionados.\nFavor intentar más tarde o contactar a su administrador.";
					if (err.error.errors) {
						this.currentSwal.text += this.utilities.setErrorMessageFromArray(err.error);
					}
					this.currentSwal.fire();
				},
				() => {
					this.loading = false;
					this.ref.detectChanges();
				}
			);
		} else {
			Swal.fire({
				icon: "error",
				title: "Error de Selección",
				text: "No se ha seleccionado ningún documento para envío.\nFavor seleccionar un documento con la columna selectora.",
			});
		}
	}

	getDownloadFilesObservable(Ids: string[], type: string): Observable<any> {
		const downloadRequest = {
			dteIds: Ids,
			fileType: type,
		};
		return this.dteService.getZip(downloadRequest);
	}

	getDownloadFilesObservableConResultado(Ids: string[], type: string): Observable<Response<ResultadoDescargaMasiva>> {
		const downloadRequest: any = {
			dteIds: Ids,
			fileType: type,
		};
		if (type === "xml") {
			downloadRequest.permitirDescargaParcialSinXml = true;
		}

		return this.dteService.getZipConResultado(downloadRequest);
	}

	private mostrarResultadoDescargaMasiva(downloadResult: ResultadoDescargaMasiva) {
		const omittedCount = downloadResult?.cantidadOmitida ?? 0;
		const omittedImportedCount = downloadResult?.cantidadOmitidaImportados ?? 0;
		const omittedNotImportedCount = downloadResult?.cantidadOmitidaNoImportados ?? 0;
		const downloadedCount = downloadResult?.cantidadDescargada ?? 0;
		const omittedPreview = downloadResult?.detalleOmitidos;

		if (omittedCount > 0) {
			const omittedSummary = this.construirResumenOmitidos(
				omittedCount,
				omittedImportedCount,
				omittedNotImportedCount
			);
			this.currentSwal.icon = "warning";
			this.currentSwal.title = "Descarga parcial de documentos";
			this.currentSwal.text = `Se descargaron ${downloadedCount} documentos y ${omittedSummary}.`;
			if (omittedPreview) {
				this.currentSwal.text += `\nDetalle: ${omittedPreview}`;
			}
			this.currentSwal.fire();
			return;
		}

		this.currentSwal.icon = "success";
		this.currentSwal.title = "Descarga de documentos";
		this.currentSwal.text = "Los documentos seleccionados se han descargado";
		this.currentSwal.fire();
	}

	private manejarErrorDescargaMasiva(err: any) {
		this.loading = false;
		this.ref.detectChanges();
		console.log(err);

		const parsedError = err?.error;
		if (parsedError?.message === "No hay XML disponibles para descargar") {
			const downloadResult = parsedError?.data as ResultadoDescargaMasiva;
			const omittedCount = downloadResult?.cantidadOmitida ?? 0;
			const omittedImportedCount = downloadResult?.cantidadOmitidaImportados ?? 0;
			const omittedNotImportedCount = downloadResult?.cantidadOmitidaNoImportados ?? 0;
			const omittedPreview = downloadResult?.detalleOmitidos;
			const omittedSummary = this.construirResumenOmitidos(
				omittedCount,
				omittedImportedCount,
				omittedNotImportedCount
			);
			this.currentSwal.icon = "warning";
			this.currentSwal.title = "Sin XML disponibles";
			this.currentSwal.text = omittedSummary
				? `No hay XML disponibles para descargar en la seleccion realizada. ${omittedSummary}.`
				: "No hay XML disponibles para descargar en la seleccion realizada.";
			if (omittedPreview) {
				this.currentSwal.text += `\nDetalle: ${omittedPreview}`;
			} else {
				const omittedDetail = this.obtenerDetalleOmitidos(parsedError?.errors);
				if (omittedDetail) {
					this.currentSwal.text += `\n${omittedDetail}`;
				}
			}
			this.currentSwal.fire();
			return;
		}

		this.currentSwal.icon = "error";
		this.currentSwal.title = "Error en exportación";
		this.currentSwal.text = "No ha sido posible descargar los documentos seleccionados.\nFavor intentar más tarde o contactar a su administrador.";
		if (parsedError?.errors) {
			this.currentSwal.text += this.utilities.setErrorMessageFromArray(parsedError);
		}
		this.currentSwal.fire();
	}

	private obtenerDetalleOmitidos(errors: string[] | undefined): string {
		if (!errors || errors.length === 0) {
			return "";
		}

		const detail = errors.find((error) => error?.startsWith("Detalle omitidos:"));
		return detail ?? "";
	}

	private construirResumenOmitidos(
		omittedCount: number,
		omittedImportedCount: number,
		omittedNotImportedCount: number
	): string {
		const summaries: string[] = [];
		if (omittedImportedCount > 0) {
			const importedDocText = omittedImportedCount === 1 ? "documento importado" : "documentos importados";
			summaries.push(`se omitieron ${omittedImportedCount} ${importedDocText} (sin XML)`);
		}

		if (omittedNotImportedCount > 0) {
			const notImportedDocText = omittedNotImportedCount === 1 ? "documento" : "documentos";
			summaries.push(`se omitieron ${omittedNotImportedCount} ${notImportedDocText} sin XML`);
		}

		if (summaries.length === 0 && omittedCount > 0) {
			const omittedDocText = omittedCount === 1 ? "documento" : "documentos";
			summaries.push(`se omitieron ${omittedCount} ${omittedDocText} sin XML`);
		}

		return summaries.join(" y ");
	}

	getDocumentSubscription(dteId: string, docType: string): Subscription {
		switch (docType) {
			case "pdf":
				return this.dteService.getPdf(dteId).subscribe();
				break;
			case "pdf":
				break;
			case "both":
				break;
			default:
				break;
		}
	}

	// getDownloadXmlObservable(id: string): Observable<Response<any>> {
	// 	return this.dteService.getXml(id);
	// }
	// getDownloadPdfObservable(id: string, tipoDte: number): Observable<Response<any>> {
	// 	if (tipoDte == 43) return this.dteService.getPdfLiquidacion(id);
	// 	else return this.dteService.getPdf(id);
	// }

	responseToPdfDownload(responseB64, currentDte: DteEmitido) {
		const pdfBlob = this.utilities.convertB64ToBlob(responseB64, "application/pdf");
		FileSaver.saveAs(pdfBlob, currentDte.folio + "_" + currentDte.codigoTipoDte + "_dte.pdf");
		this.loading = false;
		this.ref.detectChanges();
	}
	convertStreamToFileDownload(responseB64, currentDte: DteEmitido, fileType: string, extensionFile: string) {
		const docBlob = this.utilities.convertB64ToBlob(responseB64, fileType);
		FileSaver.saveAs(docBlob, currentDte.folio + "_" + currentDte.razonSocial + "_dte." + extensionFile);
	}

	openDocumentSenderModal(modalRef, row?: DteEmitido) {
		if (row) {
			this.selectedItem = row;
		} else if (this.selected.length > 0) {
			this.selectedItem = undefined;
		} else {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Error de Selección";
			this.currentSwal.text = "No se ha seleccionado ningún documento para envío.\nFavor seleccionar un documento con la columna selectora o usar la emisión individual desde el icono de 'Enviar Correo'";
			this.currentSwal.fire();
			return;
		}
		this.cargarCorreoDestinatario(row || this.selected[0], modalRef);
	}

	openMassEmailModal(modalRef) {
		// Verificar que hay documentos seleccionados
		if (this.selected.length === 0) {
			this.currentSwal.icon = "error";
			this.currentSwal.title = "Error de Selección";
			this.currentSwal.text = "No se ha seleccionado ningún documento para envío masivo.\nFavor seleccionar uno o más documentos con la columna selectora.";
			this.currentSwal.fire();
			return;
		}
		const primero = this.selected[0];
		const differentReceptors = this.selected.some(dte => dte.rutReceptor !== primero.rutReceptor ||
			(esRutGenerico(primero.rutReceptorDv || primero.rutReceptor) && (primero.clienteId ? dte.clienteId !== primero.clienteId :
				dte.razonSocial?.trim().toUpperCase() !== primero.razonSocial?.trim().toUpperCase())));
		if (differentReceptors) {
			this.currentSwal.icon = "warning";
			this.currentSwal.title = "Clientes diferentes";
			this.currentSwal.text = "Seleccione documentos del mismo cliente para usar un destinatario común.";
			this.currentSwal.fire();
			return;
		}

		this.selectedItem = undefined;
		this.senderForm.reset();
		this.senderForm.controls.sendPdfCheckbox.setValue(true);
		this.senderForm.controls.sendXmlCheckbox.setValue(true);
		this.cargarCorreoDestinatario(this.selected[0], modalRef);
	}

	private cargarCorreoDestinatario(dte: DteEmitido, modalRef): void {
		this.senderForm.controls.receiverEmail.setValue("");
		this.senderForm.controls.ccEmail.setValue("");
		const desdeXml = (dte.codigoTipoDte === 43 ? this.dteService.getReceptorDteLiquidacion(dte.dteId) : this.dteService.getReceptorDte(dte.dteId))
			.pipe(map(response => response.data));
		const desdeHistorico: Observable<Receptor> = desdeXml.pipe(switchMap(receptor => receptor?.clienteId
			? this.clienteService.get(receptor.receptorId || dte.receptorId, dte.emisorId || this.emisorId, receptor.clienteId)
				.pipe(map(response => response.data), catchError(() => of(receptor)))
			: of(receptor)));
		const destinatario: Observable<Receptor> = dte.clienteId
			? this.clienteService.get(dte.receptorId, dte.emisorId || this.emisorId, dte.clienteId).pipe(map(response => response.data), catchError(() => desdeXml))
			: desdeHistorico;
		destinatario.subscribe({
			next: receptor => {
				const correo = receptor?.correoFact === "sincorreo@sincorreo.cl" ? "" : receptor?.correoFact || "";
				const copia = receptor?.correoPar === "sincorreo@sincorreo.cl" ? "" : receptor?.correoPar || "";
				this.senderForm.controls.receiverEmail.setValue(correo);
				this.senderForm.controls.ccEmail.setValue(copia !== correo ? copia : "");
				this.abrirModalCorreos(modalRef);
			},
			error: () => this.abrirModalCorreos(modalRef),
		});
	}

	abrirModalCorreos(modalRef) {
		// Inicializar paginación cuando se abre el modal
		this.modalCurrentPage = 1;
		this.modalTotalItems = this.selected.length;

		this.senderDteModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});

		this.senderDteModal.closed.subscribe((res) => {
			this.senderForm.reset();
		});
		this.senderDteModal.dismissed.subscribe((res) => {
			this.senderForm.reset();
		});
	}

	get modalPaginatedItems() {
		const startIndex = (this.modalCurrentPage - 1) * this.modalItemsPerPage;
		const endIndex = startIndex + this.modalItemsPerPage;
		return this.selected.slice(startIndex, endIndex);
	}

	get modalTotalPages() {
		return Math.ceil(this.modalTotalItems / this.modalItemsPerPage);
	}

	modalNextPage() {
		if (this.modalCurrentPage < this.modalTotalPages) {
			this.modalCurrentPage++;
		}
	}

	modalPrevPage() {
		if (this.modalCurrentPage > 1) {
			this.modalCurrentPage--;
		}
	}

	modalGoToPage(page: number) {
		if (page >= 1 && page <= this.modalTotalPages) {
			this.modalCurrentPage = page;
		}
	}

	createSenderForm() {
		this.senderForm = this.formBuilder.group(
			{
				receiverEmail: [
					"",
					[
						Validators.required,
						//Validators.pattern(this.formConfig.emailPatternRegex),
						MultipleEmailValidator,
						Validators.maxLength(320),
					],
				],
				ccEmail: [
					"",
					[
						//Validators.pattern(this.formConfig.emailPatternRegex),
						MultipleEmailValidator,
						Validators.maxLength(320),
					],
				],
				ccoEmail: [
					"",
					[
						//Validators.email,
						//Validators.pattern(this.formConfig.emailPatternRegex),
						MultipleEmailValidator,
						Validators.maxLength(320),
					],
				],
				sendPdfCheckbox: [true],
				sendXmlCheckbox: [true],
				comments: [""],
			},
			{ validators: SameWordEmailValidator }
		);
	}

	onSubmitSenderForm() {
		if (this.senderForm.valid) {
			// Validar que se seleccionó al menos un tipo de documento (PDF o XML)
			if (!this.senderForm.controls.sendPdfCheckbox.value && !this.senderForm.controls.sendXmlCheckbox.value) {
				Swal.fire({
					title: "Documentos No Seleccionados",
					text: "Favor indicar por lo menos un documento a enviar",
					icon: "info",
				});
				return;
			}

			let emailReceivers: string[] = this.senderForm.controls.receiverEmail.value
				.toString()
				.split(",")
				.map((email) => email.trim());

			let emailsCCs: string[] = this.senderForm.controls.ccEmail.value
				? this.senderForm.controls.ccEmail.value
					.toString()
					.split(",")
					.map((email) => email.trim())
				: [];

			let emailCCOs: string[] = this.senderForm.controls.ccoEmail.value
				? this.senderForm.controls.ccoEmail.value
					.toString()
					.split(",")
					.map((email) => email.trim())
				: [];
			if (this.selectedItem) {
				// Envío individual
				this.showConfirmationAndSendIndividual(emailReceivers, emailsCCs, emailCCOs);
			} else if (this.selected.length > 0) {
				// Envío masivo
				this.showConfirmationAndSendMassive(emailReceivers, emailsCCs, emailCCOs);
			} else {
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error de Selección";
				this.currentSwal.text = "No se ha seleccionado ningún documento para envío.";
				this.currentSwal.fire();
				return;
			}
		}
	}
	showConfirmationAndSendIndividual(emailReceivers: string[], emailsCCs: string[], emailCCOs: string[]) {
		const primaryEmail = emailReceivers[0];

		Swal.fire({
			title: 'Confirmar Envío',
			text: `¿Desea enviar el DTE ${this.selectedItem.folio} al correo ${primaryEmail}?`,
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Sí, Enviar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33'
		}).then((result) => {
			if (result.isConfirmed) {
				var mailRequest = new SendInvoiceRequest();
				mailRequest.ccos = emailCCOs;
				mailRequest.ccs = emailsCCs;
				mailRequest.dteId = this.selectedItem.dteId;
				mailRequest.dteType = this.selectedItem.codigoTipoDte;
				mailRequest.to = emailReceivers;
				mailRequest.emailType = 3;
				mailRequest.pdf = this.senderForm.controls.sendPdfCheckbox.value ? true : false;
				mailRequest.xml = this.senderForm.controls.sendXmlCheckbox.value ? true : false;
				mailRequest.IssuingId = this.selectedItem.emisorId;
				mailRequest.comments = this.senderForm.controls.comments.value;

				this.sendDteDocuments(mailRequest);
			}
		});
	}
	showConfirmationAndSendMassive(emailReceivers: string[], emailsCCs: string[], emailCCOs: string[]) {
		const primaryEmail = emailReceivers;
		const dteCount = this.selected.length;

		Swal.fire({
			title: 'Confirmar Envío Masivo',
			text: `¿Desea enviar los ${dteCount} DTEs seleccionados al correo ${primaryEmail}?`,
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Sí, Enviar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33'
		}).then((result) => {
			if (result.isConfirmed) {
				this.sendMassiveDteDocuments(emailReceivers, emailsCCs, emailCCOs);
			}
		});
	}
	sendMassiveDteDocuments(emailReceivers: string[], emailsCCs: string[], emailCCOs: string[]) {
		const totalDtes = this.selected.length;

		Swal.fire({
			title: 'Enviando documentos...',
			text: `Enviando ${totalDtes} documentos por correo`,
			allowOutsideClick: false,
			didOpen: () => {
				Swal.showLoading();
			}
		});

		var mailRequest = new SendInvoicemasiveRequest();
		mailRequest.ccos = emailCCOs;
		mailRequest.ccs = emailsCCs;
		mailRequest.dteId = this.selected.map(dte => dte.dteId);
		mailRequest.dteType = this.selected[0].codigoTipoDte;
		mailRequest.to = emailReceivers;
		mailRequest.emailType = 3;
		mailRequest.pdf = this.senderForm.controls.sendPdfCheckbox.value ? true : false;
		mailRequest.xml = this.senderForm.controls.sendXmlCheckbox.value ? true : false;
		mailRequest.IssuingId = this.selected[0].emisorId;
		mailRequest.comments = this.senderForm.controls.comments.value;
		this.correoEnvioService.sendMassiveEmail(mailRequest).subscribe({
			next: (response) => {
				if (response.data) {
					this.showMassiveSendResults(totalDtes, 0, [], totalDtes);
				} else {
					this.showMassiveSendResults(0, totalDtes, [response.message || 'Error en envío masivo'], totalDtes);
				}
			},
			error: (error) => {
				this.showMassiveSendResults(0, totalDtes, [error.message || 'Error desconocido'], totalDtes);
			},
			complete: () => {
				if (this.senderDteModal) {
					this.senderDteModal.close();
				}
				this.selected = [];
				this.selectedItem = undefined;
			}
		});
	}
	showMassiveSendResults(successCount: number, errorCount: number, errorMessages: string[], totalDtes: number) {
		if (errorCount === 0) {
			Swal.fire({
				title: '¡Envío Exitoso!',
				text: `Se enviaron exitosamente ${successCount} de ${totalDtes} documentos por correo.`,
				icon: 'success',
				confirmButtonText: 'Entendido'
			});
		} else if (successCount === 0) {
			Swal.fire({
				title: 'Error en Envío',
				text: `No se pudo enviar ningún documento. ${errorCount} envíos fallaron.`,
				icon: 'error',
				confirmButtonText: 'Entendido'
			});
		} else {
			const errorDetails = errorMessages.join('\n');
			Swal.fire({
				title: 'Envío Parcial',
				html: `
					<p><strong>Enviados exitosamente:</strong> ${successCount} de ${totalDtes}</p>
					<p><strong>Errores:</strong> ${errorCount}</p>
					<div style="text-align: left; margin-top: 10px;">
						<strong>Detalles de errores:</strong><br>
						<pre style="background: #f5f5f5; padding: 10px; border-radius: 4px; max-height: 200px; overflow-y: auto;">${errorDetails}</pre>
					</div>
				`,
				icon: 'warning',
				confirmButtonText: 'Entendido',
				width: '600px'
			});
		}
	}

	// onSubmitEmail() {
	// 	// email request to backend handling
	// 	//valid form data
	// 	if (this.senderForm.valid) {
	// 		//get dtes id array
	// 		let dteIdList: Array<string> = [];
	// 		if (this.selectedItem) {
	// 			dteIdList.push(this.selectedItem.dteId);
	// 		} else if (this.selected.length > 0) {
	// 			this.selected.forEach((dte) => {
	// 				dteIdList.push(dte.dteId);
	// 			});
	// 		}
	// 		//attach xml pdf or both seing boolean in request
	// 		let sendingPdf: boolean = this.senderForm.controls.sendPdfCheckbox.value;
	// 		let sendingXml: boolean = this.senderForm.controls.sendXmlCheckbox.value;
	// 		//attach array of email addresses
	// 		let arrayReceiversEmails: string[] = this.senderForm.controls.receiverEmail.value.toString().split(",");
	// 		let arrayCopyEmails: string[] = this.senderForm.controls.ccEmail.value.toString().split(",");
	// 		let arrayBlindCopyEmails: string[] = this.senderForm.controls.ccoEmail.value.toString().split(",");
	// 	}
	// }

	// setDataAttachmentToRequest(
	//   req: SendInvoiceRequest,
	//   dteToSend: DteEmitido,
	//   fileString: string,
	//   extensionString: string
	// ) {
	//   let docDate = this.datePipe.transform(dteToSend.fecha, "dd/MM/yyyy");
	//   let docName =
	//     dteToSend.folio +
	//     "_" +
	//     dteToSend.rutReceptor +
	//     "_" +
	//     docDate +
	//     "_" +
	//     dteToSend.razonSocial +
	//     extensionString;
	//   let nombreCompletoTipoDte:TipoDte = this.tipoDteSource.find(tipo => tipo.tipoDteId == dteToSend.tipoDteId);
	//   req.data = new EmailData(docName, docDate,dteToSend.razonSocial,nombreCompletoTipoDte.nombre,dteToSend.folio.toString(),dteToSend.rutReceptorDv,dteToSend.total);
	//   req.attachments = [new EmailAttachment(docName, fileString)];
	// }

	copiar(row) {
		let invoiceType = InvoiceType.Factura;
		switch (row.codigoTipoDte) {
			case 33:
			case 34:
				invoiceType = InvoiceType.Factura;
				break;
			case 39:
			case 41:
				invoiceType = InvoiceType.Boleta;
				break;
			case 61:
				invoiceType = InvoiceType.NotaCredito;
				break;
			case 56:
				invoiceType = InvoiceType.NotaDebito;
				break;
			case 43:
				invoiceType = InvoiceType.LiquidacionFactura;
				break;
		}
		this.router.navigateByUrl("facturador-individual", {
			state: { dteExistente: row, invoiceType: invoiceType },
		});
	}

	sendDteDocuments(request: SendInvoiceRequest) {
		this.loading = true;
		this.ref.detectChanges();
		this.correoEnvioService.sendEmail(request).subscribe(
			(result) => {
				let resumenEnvioCorreo: string = "";
				resumenEnvioCorreo = "Se envió el documento a las siguientes direcciones:<br>" + request.to + "<br>";
				if (request.ccs[0] != "") {
					if (request.ccs.length > 0) {
						resumenEnvioCorreo += "<br> Con copia a las siguientes direcciones:<br>" + request.ccs + "<br>";
					}
				}
				if (request.ccos[0] != "") {
					if (request.ccos.length > 0) {
						resumenEnvioCorreo += "<br> Con copia oculta para las siguientes direcciones:<br>" + request.ccos;
					}
				}
				Swal.fire({
					icon: "success",
					title: "Envío exitoso",
					showCloseButton: true,
					html: "<div style='text-align:center;'><p>" + resumenEnvioCorreo + "</p></div>",
				});
				this.senderDteModal.close();
				this.senderForm.reset();
				this.senderForm.controls.ccEmail.patchValue("");
				this.senderForm.controls.ccoEmail.patchValue("");
				this.senderForm.controls.receiverEmail.patchValue("");
				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error en el envío";
				this.currentSwal.text = "No fue posible enviar el documento." + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.fire();
			},
			() => {
				this.loading = false;
				this.ref.detectChanges();
			}
		);
	}

	async getPdfForEmailRequest(dteId: string, pdfStringRef: string, tipoDte: number) {
		var pdfStringRef = "";
		if (tipoDte == 43) {
			pdfStringRef = await (await this.dteService.getPdfLiquidacion(dteId).toPromise()).data;
		} else {
			pdfStringRef = await (await this.dteService.getPdf(dteId).toPromise()).data;
		}

		return pdfStringRef;
	}

	getXml(dte: DteEmitido) {
		this.dteService.getXml(dte.dteId).subscribe(
			(result) => {
				this.loading = true;
				let b64Response = result.data.xml;
				const blobXml = this.utilities.convertB64ToBlob(b64Response, "text/xml");
				let blob = new Blob([blobXml], { type: "text/xml" });
				let fileURL = URL.createObjectURL(blobXml);
				this.popupCenter(fileURL, "Documentos Tributario Electrónico", 600, 800);
				this.loading = false;
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error en XML";
				this.currentSwal.text = "No fue posible obtener el documento." + this.utilities.setErrorMessageFromArray(error.error);
				this.currentSwal.fire();
			},
			() => {
				this.loading = false;
			}
		);
	}

	popupCenter(url, title, w, h) {
		const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
		const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

		const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
		const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

		const systemZoom = width / window.screen.availWidth;
		const left = (width - w) / 2 / systemZoom + dualScreenLeft;
		const top = (height - h) / 2 / systemZoom + dualScreenTop;
		const newWindow = window.open(
			url,
			title,
			`
    scrollbars=yes,
    width=${w / systemZoom}, 
    height=${h / systemZoom}, 
    top=${top}, 
    left=${left}    
	 `
		);
		if (window.focus) {
			newWindow.focus();
		}
	}

	//trazabilidad
	openTraceShowModal(modalRef, dte: DteEmitido) {
		this.dteToShow = dte;
		this.loading = true;
		this.dteService
			.getTrace(this.dteToShow.dteId)
			.subscribe(
				(result) => {
					this.tracesToShow = result.data as Traza[];
					this.loading = false;
					this.ref.detectChanges();
				},
				(error) => {
					this.loading = false;
					this.currentSwal.icon = "error";
					this.currentSwal.title = "Error en Trazabilidad";
					this.currentSwal.text = "No es posible obtener la trazabilidad de este documento. Intente mas tarde. ";
					this.currentSwal.text += this.utilities.setErrorMessageFromArray(error.error);

					this.currentSwal.fire();
				},
				() => {
					this.loading = false;
				}
			)
			.add(() => {
				this.loading = false;
				this.tracesModal = this.modalService.open(modalRef, {
					windowClass: "",
					size: "lg",
					centered: true,
				});
			});
	}
	get mostrarMsgSii(): boolean {
		const estado = this.dteToShow?.estadoSii;
		const hayCorreo = this.tracesToShow?.some((t) => t.descripcion?.toLowerCase().includes("validación desde correo"));
		if (this.dteToShow?.codigoTipoDte === 39 || this.dteToShow?.codigoTipoDte === 41) {
			return false;
		}
		return (estado === 5 || estado === 7) && !hayCorreo;
	}
	openAnularDteModal(modalRef: any, dte: DteEmitido) {
		// Solo validamos si:
		// - el emisor tiene Payku activo
		// - el DTE es Factura/Boleta (electrónica o exenta: 33,34,39,41)
		if (!(this.tienePayku && this.isFacturaOrBoleta(dte.codigoTipoDte))) {
			this.proceedOpenAnularDteModal(modalRef, dte);
			return;
		}

		this.loading = true;
		this.paykuService.estaLiquidado(dte.dteId).subscribe({
			next: (res) => {
				this.loading = false;
				this.ref.detectChanges();

				const liquidado = typeof res === 'boolean' ? res : !!res?.data;

				if (liquidado) {
					Swal.fire({
						icon: 'warning',
						title: 'Documento liquidado',
						html: `
					Este documento ya fue <b>liquidado</b> vía Payku.<br>
					Si continúas con la generación de la nota, deberás
					<b>regularizar manualmente</b> con el receptor.
					<br><br>¿Deseas continuar de todas formas?
				`,
						showCancelButton: true,
						confirmButtonText: 'Sí, continuar',
						cancelButtonText: 'Cancelar',
						confirmButtonColor: '#1BC5BD',
						cancelButtonColor: '#F64E60',
						heightAuto: false
					}).then(r => {
						if (r.isConfirmed) this.proceedOpenAnularDteModal(modalRef, dte);
					});
				} else {
					this.proceedOpenAnularDteModal(modalRef, dte);
				}
			},
			error: (_) => {
				this.loading = false;
				this.ref.detectChanges();
				// No bloqueamos el flujo si la verificación falla
				Swal.fire({
					icon: 'info',
					title: 'Validación no disponible',
					text: 'No fue posible verificar si el DTE está liquidado. Continuaremos con la generación.',
					heightAuto: false
				}).then(() => this.proceedOpenAnularDteModal(modalRef, dte));
			}
		});
	}

	proceedOpenAnularDteModal(modalRef, dte: DteEmitido) {
		this.dteToNullify = dte;
		this.loading = true;
		this.dteService
			.getDetalleDte(dte.dteId)
			.subscribe(
				(result) => {
					this.ref.detectChanges();
					this.dteToNullify.detalleDte = result.data as DetalleDte[];
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					this.notesSwal.icon = "error";
					this.notesSwal.title = "Error al Obtener Detalles";
					this.notesSwal.text = "No es posible obtener los detalles del documento a anular";
					this.notesSwal.fire();
				},
				() => { }
			)
			.add(() => {
				this.dteService
					.getReferencias(dte.dteId)
					.subscribe(
						(result) => {
							let dteReferences = result.data.map((ref) => {
								return ref.dte;
							});
							dteReferences.forEach((row) => {
								this.setEmisorToElement(row);
								this.setTipoDteToElement(row);
							});
							this.dteToNullifyReferences = dteReferences;
						},
						(error) => {
							this.loading = false;
							this.ref.detectChanges();
							this.notesSwal.icon = "error";
							this.notesSwal.title = "Error al Obtener Referencias";
							this.notesSwal.text = "No es posible obtener referencias del documento a anular." + this.utilities.setErrorMessageFromArray(error.error);
							this.notesSwal.fire();
						}
					)
					.add(() => {
						this.dteService.getReceptorDte(dte.dteId).subscribe(
							(result) => {
								this.dteToNullify.receptorAsociado = result.data;
								
							},
							(error) => {
								this.loading = false;
								this.ref.detectChanges();
								this.notesSwal.icon = "error";
								this.notesSwal.title = "Error al Obtener Receptor";
								this.notesSwal.text = "No es posible obtener los detalles del receptor del documento a anular." + this.utilities.setErrorMessageFromArray(error.error);
								this.notesSwal.fire();
							}
						).add(
							() => {
								this.dteService.getDescuentosRecargos(dte.dteId)
								.subscribe(
									(result) => {
										this.loading = false;
										this.ref.detectChanges();
										const descuentos = result.data ?? [];
										this.dteToNullify.descuentoGlobal = descuentos.reduce(
										(total, dr) => total + (dr.valor ?? 0),
										0
										);										
										this.anuladorModal = this.modalService.open(modalRef, {
											windowClass: "",
											size: "lg",
										});
									},
									(error) => {
										this.loading = false;
										this.ref.detectChanges();
										this.notesSwal.icon = "error";
										this.notesSwal.title = "Error al Obtener Descuentos/Recargos";
										this.notesSwal.text = "No es posible obtener los descuentos/recargos del documento a anular." + this.utilities.setErrorMessageFromArray(error.error);
										this.notesSwal.fire();
										}
								);
							}
						);
					});
			});
	}

	closeAnularDteModal() {
		this.anuladorModal.close();
	}

	getTraza(dte: DteEmitido) { }

	// getAllRowsByFilter(currentFilter: DteFilter) {
	// 	this.loading = true;
	// 	//this.f.selectedRangeDate.value.startDate
	// 	// currentFilter.fechaDesde = this.dateExportacion.startDate.format('YYYY-MM-DD');
	// 	// currentFilter.fechaHasta = this.dateExportacion.endDate.format('YYYY-MM-DD');
	// 	this.dteService.getDataToExport(currentFilter).subscribe(
	// 		(result) => {
	// 			let elements = result as DteEmitido[];
	// 			elements.forEach((row) => {
	// 				this.setEmisorToElement(row);
	// 				this.setTipoDteToElement(row);
	// 			});
	// 			this.loading = false;
	// 			this.ref.detectChanges();
	// 			this.exportExcelData(elements);
	// 		},
	// 		(error) => {
	// 			this.loading = false;
	// 			this.ref.detectChanges();
	// 			this.currentSwal.icon = "error";
	// 			this.currentSwal.title = "Error al exportar";
	// 			this.currentSwal.text = "No es posible exportar los datos. Intente mas tarde. ";
	// 			this.currentSwal.text += this.utilities.setErrorMessageFromArray(error.error);
	// 		},
	// 		() => {
	// 			this.loading = false;
	// 			this.ref.detectChanges();
	// 		}
	// 	);
	// }

	commaSepEmail = (control: AbstractControl): { [key: string]: any } | null => {
		const emails = control.value.split(",").map((e) => e.trim());
		const forbidden = emails.some((email) => this.formConfig.emailPatternRegex.test(email));
		return forbidden ? { toAddress: { value: control.value } } : null;
	};

	newCreditNote(data: NotaCredito) {
        if (this.loading) return; // Evita dos emisiones desde un doble clic mientras hay una solicitud en curso.
		var type = "";
		let notaCreditoDte = new DteEmitido();
		notaCreditoDte.nombreTipoDte = "Nota de Crédito Electrónica";
		notaCreditoDte.folio = 1000;
		notaCreditoDte.emisorAsociado = data.dteReferencia.emisorAsociado;
		notaCreditoDte.rutReceptorDv = data.dteReferencia.rutReceptorDv;
		notaCreditoDte.razonSocial = data.dteReferencia.razonSocial;
		notaCreditoDte.fecha = new Date();
		if (data.tipoNota == 0) {
			notaCreditoDte.total = data.dteReferencia.total;
			type = "Anulación";
		} else if (data.tipoNota == 2) {
			notaCreditoDte.total = 0;
			type = "Corrección de Texto";
		} else {
			notaCreditoDte.total = data.total;
			type = "Corrección de Monto";
		}
		this.loading = true;
		if (data.dteReferencia.codigoTipoDte == 110) {
			this.dteService.creditNoteDteExportNullification(data).subscribe(
				(result) => {
					let dteResult = result.data as DteEmitido;
					notaCreditoDte.dteId = dteResult.dteId;
					notaCreditoDte.folio = dteResult.folio;
					notaCreditoDte.estadoSii = dteResult.estadoSii;
					notaCreditoDte.nombreTipoDte = "NC.EX.E";
					notaCreditoDte.codigoTipoDte = 112;
					notaCreditoDte.anulado = false;
					notaCreditoDte.notaCreditoHabilitada = false;
					notaCreditoDte.notaDebitoHabilitada = true;
					notaCreditoDte.rutReceptor = data.dteReferencia.rutReceptor;
					notaCreditoDte.rutReceptorDv = data.dteReferencia.rutReceptorDv;
					notaCreditoDte.neto = data.tipoNota == 0 ? data.dteReferencia.neto : data.neto;
					notaCreditoDte.iva = data.tipoNota == 0 ? data.dteReferencia.iva : data.iva;
					notaCreditoDte.exento = data.dteReferencia.exento;
					//this.setTipoDteToElement(notaCreditoDte);
					// this.rowsMantenedor.unshift(notaCreditoDte);
					// this.rowsMantenedor = [...this.rowsMantenedor];
					this.refreshCurrentPage();
					this.loading = false;
					this.ref.detectChanges();
					this.notesSwal.icon = "success";
					this.notesSwal.title = "Documento Generado";
					this.notesSwal.text = result.message || "Se ha generado el documento correctamente";
					this.notesSwal.fire();
					if (data.tipoNota == 0) {
						this.updateConditionOfDte(data.dteReferenciaId, "anulado", true);
					}
					this.anuladorModal.close();
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					this.notesSwal.icon = "error";
					this.notesSwal.title = "Error en Nota de Credito de tipo  " + type;
					this.notesSwal.text = "Ha ocurrido un error al intentar generar el documento.\n";
					if (error.error.errors) {
						error.error.errors.forEach((errorMsg) => {
							this.notesSwal.text += "\n" + errorMsg + "\n";
						});
					}
					this.notesSwal.fire();
				},
				() => {
					this.loading = false;
					this.ref.detectChanges();
				}
			);
		} else {
			this.dteService.creditNoteNullification(data).subscribe(
				(result) => {
					let dteResult = result.data as DteEmitido;
					notaCreditoDte.dteId = dteResult.dteId;
					notaCreditoDte.folio = dteResult.folio;
					notaCreditoDte.estadoSii = dteResult.estadoSii;
					notaCreditoDte.nombreTipoDte = "N.C.E";
					notaCreditoDte.codigoTipoDte = 61;
					notaCreditoDte.anulado = false;
					notaCreditoDte.notaCreditoHabilitada = false;
					notaCreditoDte.notaDebitoHabilitada = true;
					notaCreditoDte.rutReceptor = data.dteReferencia.rutReceptor;
					notaCreditoDte.rutReceptorDv = data.dteReferencia.rutReceptorDv;
					notaCreditoDte.neto = data.tipoNota == 0 ? data.dteReferencia.neto : data.neto;
					notaCreditoDte.iva = data.tipoNota == 0 ? data.dteReferencia.iva : data.iva;
					notaCreditoDte.exento = data.dteReferencia.exento;
					//this.setTipoDteToElement(notaCreditoDte);
					// this.rowsMantenedor.unshift(notaCreditoDte);
					// this.rowsMantenedor = [...this.rowsMantenedor];
					this.loading = false;
					this.ref.detectChanges();
					this.refreshCurrentPage();
					this.notesSwal.icon = "success";
					this.notesSwal.title = "Documento Generado";
					this.notesSwal.text = result.message || "Se ha generado el documento correctamente";
					this.notesSwal.fire();
					if (data.tipoNota == 0) {
						this.updateConditionOfDte(data.dteReferenciaId, "anulado", true);
					}
					this.anuladorModal.close();
				},
				(error) => {
					this.loading = false;
					console.log(error);
					this.ref.detectChanges();
					this.notesSwal.icon = "error";
					this.notesSwal.title = "Error en Nota de Credito de tipo " + type;
					this.notesSwal.text = "Ha ocurrido un error al intentar generar el documento.\n";
					if (error.error.errors) {
						error.error.errors.forEach((errorMsg) => {
							this.notesSwal.text += "\n" + errorMsg + "\n";
						});
					}
					this.notesSwal.fire();
				},
				() => {
					this.loading = false;
					this.ref.detectChanges();
				}
			);
		}
	}
	newDebitNoteNullification(data: NotaDebito) {
		let dte = new DteEmitido();
		dte.nombreTipoDte = "Nota de Debito Electrónica";
		dte.folio = 1000;
		dte.emisorAsociado = data.dteReferencia.emisorAsociado;
		dte.rutReceptorDv = data.dteReferencia.rutReceptorDv;
		dte.razonSocial = data.dteReferencia.razonSocial;
		dte.fecha = new Date();
		if (data.tipoNota == 0) {
			dte.total = data.dteReferencia.total;
		} else if (data.tipoNota == 2) {
			dte.total = 0;
		} else {
			dte.total = data.total;
		}
		this.loading = true;
		if (data.dteReferencia.codigoTipoDte == 112) {
			this.dteService.debitNoteDteExportNullification(data).subscribe(
				(result) => {
					let dteResult = result.data as DteEmitido;
					dte.dteId = dteResult.dteId;
					dte.folio = dteResult.folio;
					dte.estadoSii = dteResult.estadoSii;
					dte.nombreTipoDte = "ND.EX.E";
					dte.codigoTipoDte = 111;
					dte.anulado = false;
					dte.notaCreditoHabilitada = false;
					dte.notaDebitoHabilitada = false;
					//this.setTipoDteToElement(dte);
					// this.rowsMantenedor.unshift(dte);
					// this.rowsMantenedor = [...this.rowsMantenedor];
					this.loading = false;
					this.ref.detectChanges();
					this.refreshCurrentPage();
					this.notesSwal.icon = "success";
					this.notesSwal.title = "Documento Generado";
					this.notesSwal.text = "Se ha generado el documento correctamente";
					this.notesSwal.fire();
					if (data.tipoNota == 0) {
						this.updateConditionOfDte(data.dteReferenciaId, "anulado", true);
					}
					this.anuladorModal.close();
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					this.notesSwal.icon = "error";
					this.notesSwal.title = "Error en anulación";
					this.notesSwal.text = "Ha ocurrido un error al intentar generar el documento.\n";
					if (error.error.errors) {
						error.error.errors.forEach((errorMsg) => {
							this.notesSwal.text += "\n" + errorMsg + "\n";
						});
					}
					this.notesSwal.fire();
				}
			);
		} else {
			this.dteService.debitNoteNullification(data).subscribe(
				(result) => {
					let dteResult = result.data as DteEmitido;
					dte.dteId = dteResult.dteId;
					dte.folio = dteResult.folio;
					dte.estadoSii = dteResult.estadoSii;
					dte.nombreTipoDte = "N.D.E";
					dte.codigoTipoDte = 56;
					dte.anulado = false;
					dte.notaCreditoHabilitada = false;
					dte.notaDebitoHabilitada = false;
					//this.setTipoDteToElement(dte);
					// this.rowsMantenedor.unshift(dte);
					// this.rowsMantenedor = [...this.rowsMantenedor];
					this.loading = false;
					this.ref.detectChanges();
					this.refreshCurrentPage();
					this.notesSwal.icon = "success";
					this.notesSwal.title = "Documento Generado";
					this.notesSwal.text = "Se ha generado el documento correctamente";
					this.notesSwal.fire();
					if (data.tipoNota == 0) {
						this.updateConditionOfDte(data.dteReferenciaId, "anulado", true);
					}
					this.anuladorModal.close();
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					this.notesSwal.icon = "error";
					this.notesSwal.title = "Error en anulación";
					this.notesSwal.text = "Ha ocurrido un error al intentar generar el documento.\n";
					if (error.error.errors) {
						error.error.errors.forEach((errorMsg) => {
							this.notesSwal.text += "\n" + errorMsg + "\n";
						});
					}
					this.notesSwal.fire();
				}
			);
		}
	}
	newDebitNoteInterest(data: NotaDebito) {
		let dte = new DteEmitido();
		dte.nombreTipoDte = "Nota de Crédito Electrónica";
		dte.folio = 1000;
		dte.emisorAsociado = data.dteReferencia.emisorAsociado;
		dte.rutReceptorDv = data.dteReferencia.rutReceptorDv;
		dte.razonSocial = data.dteReferencia.razonSocial;
		dte.fecha = new Date();
		if (data.tipoNota == 0) {
			dte.total = data.dteReferencia.total;
		} else if (data.tipoNota == 2) {
			dte.total = 0;
		} else {
			dte.total = data.total;
		}
		this.loading = true;
		this.dteService.debitNoteNullificationInterests(data).subscribe(
			(result) => {
				let dteResult = result.data as DteEmitido;
				dte.dteId = dteResult.dteId;
				dte.folio = dteResult.folio;
				dte.estadoSii = dteResult.estadoSii;
				dte.nombreTipoDte = "N.D.E";
				dte.codigoTipoDte = 56;
				dte.anulado = false;
				dte.notaCreditoHabilitada = false;
				dte.notaDebitoHabilitada = false;
				//this.setTipoDteToElement(dte);
				// this.rowsMantenedor.unshift(dte);
				// this.rowsMantenedor = [...this.rowsMantenedor];
				this.loading = false;
				this.ref.detectChanges();
				this.refreshCurrentPage();
				this.notesSwal.icon = "success";
				this.notesSwal.title = "Documento Generado";
				this.notesSwal.text = "Se ha generado el documento correctamente";
				this.notesSwal.fire();
				if (data.tipoNota == 0) {
					this.updateConditionOfDte(data.dteReferenciaId, "anulado", true);
				}
				this.anuladorModal.close();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.notesSwal.icon = "error";
				this.notesSwal.title = "Error en anulación";
				this.notesSwal.text = "Ha ocurrido un error al intentar generar el documento.\n";
				if (error.error.errors) {
					error.error.errors.forEach((errorMsg) => {
						this.notesSwal.text += "\n" + errorMsg + "\n";
					});
				}
				this.notesSwal.fire();
			}
		);
	}

	// getCellClass({ row, column, value }): any {
	// 	return row.codigoTipoDte === 61 ? "is-monto-nota-credito number-table-alignment" : "number-table-alignment";
	// }

	updateConditionOfDte(dteId: string, dteProperty: string, propertyValue: any) {
		let currentDte = this.rowsMantenedor.find((dte) => dte.dteId == dteId);
		if (currentDte) {
			currentDte[dteProperty] = propertyValue;
		}
	}

	setSwalAndFire(swalReference: SwalComponent, iconString: SweetAlertIcon, titleString: string, textString: string) {
		swalReference.icon = iconString;
		swalReference.title = titleString;
		swalReference.text = textString;
		swalReference.fire();
	}

	navigateToFacturador(type: InvoiceType): void {
		if (!(this.permissions.canIssueInvoice(type))) { return; }
		this.router.navigateByUrl("facturador-individual", {
			state: { invoiceType: type },
		});
	}

	openCesionDte(modalRef, row) {
		this.selectedItem = row;
		this.loading = true;
		this.personasAutorizadasService.getAuthorizedPersonsByEmisor(row.emisorId).subscribe(
			(result) => {
				if (result.data.length > 0) {
					this.loading = false;
					row.emisorAsociado.personasAutorizadas = result.data;
					this.ref.detectChanges();
					this.cesionDteModal = this.modalService.open(modalRef, {
						windowClass: "",
						size: "lg",
					});
				} else {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						title: "Error en Personas Autorizadas",
						text: "El emisor actual no posee personas autorizadas, favor ingresar por lo menos una persona autorizada para realizar la Cesión del documento.",
						icon: "error",
					});
				}
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					title: "Error en Personas Autorizadas",
					text: "No se pudo obtener la lista de personas  autirizadas, favor intente nuevamente." + this.utilities.setErrorMessageFromArray(error.error),
					icon: "error",
				});
			}
		);
	}

	closeCesionDteModal() {
		this.cesionDteModal.close();
	}

	sendCesionDteRequest($event: CesionRequest) {
		this.loading = true;
		let usuario = (this.tokenService.getUser() as SessionUser).id;
		let subsidiary = this.tokenService.getSubsidiary();
		this.dteService.sendCesionRequest(usuario, subsidiary, $event).subscribe(
			(result) => {
				Swal.fire({
					icon: "success",
					title: "Cesión exitosa",
					text: "Se ha generado la cesión del documento",
				});
				this.loading = false;
				this.cesionDteModal.close();
				this.ref.detectChanges();
				this.router.navigateByUrl("/ventas/cesiones");
			},
			(error) => {
				Swal.fire({
					icon: "error",
					title: "Cesión fallida",
					text: "No ha podido generarse la cesión del documento." + this.utilities.setErrorMessageFromArray(error.error),
				});
				this.loading = false;
				this.ref.detectChanges();
			}
		);
	}

	negativeSettlement(dte: DteEmitido) {
		if (!(this.permissions.getPermission("40-21-10").asignado)) { return; }
		const fechaOriginal = moment(dte.fecha).format('YYYY-MM-DD');
		const fechaHoy = moment().format('YYYY-MM-DD');

		Swal.fire({
			icon: 'info',
			title: 'Liquidación negativa',
			html: this.construirModalHtml(dte, fechaHoy),
			showCancelButton: true,
			confirmButtonText: 'Confirmar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#1BC5BD',
			cancelButtonColor: '#F64E60',
			focusConfirm: false,
			didOpen: () => this.configurarModal(),
			preConfirm: () => this.ValidarModal(fechaOriginal)
		}).then(respuesta => {
			if (!respuesta.isConfirmed || !respuesta.value || typeof respuesta.value !== 'object' || !('fecha' in respuesta.value)) return;

			const { fecha, vencimiento } = respuesta.value as { fecha: string; vencimiento: string | null };
			const fechaSeleccionada = fecha;

			this.loading = true;
			const usuarioId = (this.tokenService.getUser() as SessionUser).id;
			const sucursalId = this.tokenService.getSubsidiary();

			this.dteService.sendDteNegativeSettlement(usuarioId, sucursalId, dte.dteId, fechaSeleccionada, vencimiento ?? undefined).subscribe(
				() => {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({ icon: 'success', title: 'Liquidación Negativa Generada', text: 'Se ha generado la liquidación negativa correctamente' });
					this.setPage({ offset: 0 });
				},
				(error) => {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({ icon: 'error', title: 'Liquidación Negativa Fallida', text: 'No se ha podido generar la liquidación negativa del documento. ' + this.utilities.setErrorMessageFromArray(error.error) });
				}
			);
		});
	}


	private construirModalHtml(dte: DteEmitido, fechaHoy: string): string {
		return `
			<div id="modalLiquidacionNegativa">
				<input type="hidden" id="fechaOriginal" value="${moment(dte.fecha).format('YYYY-MM-DD')}">

				<p style="text-align:center; margin-bottom:1px;">
					La liquidación negativa se comporta como una anulación de la liquidación de factura.
					<br/><br/><strong>Selecciona la fecha con la cual se emitirá.</strong>
				</p>

				<div style="text-align:left; margin-top:12px; font-size:14px;">
						<!-- Emisión -->
					<label style="display:flex; align-items:center; gap:8px; margin:6px 0;">
						<input type="radio" name="tipoFecha" id="radioFechaOriginal" value="original">
						<span>Usar fecha de emisión original: </span>
						<div class="fecha-label" id="fechaOriginalLabel" style="margin-left:24px;">
							${moment(dte.fecha).format('DD/MM/YYYY')}
						</div>
					</label>

					<label style="display:flex; align-items:center; gap:8px; margin:12px 0 6px;">
						<input type="radio" name="tipoFecha" id="radioOtraFecha" value="otra">
						<span>Seleccionar otra fecha de emisión: </span>
						<div>
							<input type="date" id="inputFecha" value="${fechaHoy}" max="${fechaHoy}" disabled
								style="padding:6px 8px; border:1px solid #ccc; border-radius:4px;">
						</div>
					</label>

					<!-- Vencimiento opcional -->
					<hr style="margin:14px 0 10px;opacity:.25;">
					<div style="margin:8px 0 6px;"><strong>¿Desea colocar fecha de vencimiento?</strong></div>
						<div class="d-flex flex-row" style="margin-left:4px;">	
							<label class="mr-5" style="display:flex; align-items:center; gap:8px; margin:4px 0;">
								<input type="radio" name="tieneVencimiento" id="radioVencNo" value="no" checked>
								<span>No</span>
							</label>

							<label class="ml-5" style="display:flex; align-items:center; gap:8px; margin:4px 0;">
								<input type="radio" name="tieneVencimiento" id="radioVencSi" value="si">
								<span>Sí</span>
								<div>
									<input type="date" id="inputVencimiento" disabled
										style="padding:6px 8px; border:1px solid #ccc; border-radius:4px;">
								</div>
							</label>
						</div>
				</div>
			</div>
		`;
	}


	private configurarModal(): void {
		const radioFechaOriginal = document.getElementById('radioFechaOriginal') as HTMLInputElement;
		const radioOtraFecha = document.getElementById('radioOtraFecha') as HTMLInputElement;
		const inputFecha = document.getElementById('inputFecha') as HTMLInputElement;

		const radioVencNo = document.getElementById('radioVencNo') as HTMLInputElement;
		const radioVencSi = document.getElementById('radioVencSi') as HTMLInputElement;
		const inputVencimiento = document.getElementById('inputVencimiento') as HTMLInputElement;
		const hintVenc = document.getElementById('hintVenc') as HTMLDivElement;
		const fechaOriginal = (document.getElementById('fechaOriginal') as HTMLInputElement)?.value;

		const actualizarUI = () => {
			inputFecha.disabled = !radioOtraFecha.checked;
			if (!radioOtraFecha.checked) inputFecha.blur();
			actualizarMinVencimiento();
		};

		const actualizarVencimientoUI = () => {
			inputVencimiento.disabled = !radioVencSi.checked;
			hintVenc.style.display = radioVencSi.checked ? 'block' : 'none';
			actualizarMinVencimiento();
		};

		const obtenerFechaEmision = () =>
			radioFechaOriginal.checked ? fechaOriginal : inputFecha.value;

		const actualizarMinVencimiento = () => {
			const emision = obtenerFechaEmision();
			if (emision) {
				inputVencimiento.min = emision;
				if (inputVencimiento.value && inputVencimiento.value < emision) {
					inputVencimiento.value = emision;
				}
			}
		};

		radioFechaOriginal.addEventListener('change', actualizarUI);
		radioOtraFecha.addEventListener('change', actualizarUI);
		inputFecha.addEventListener('input', actualizarMinVencimiento);

		radioVencNo.addEventListener('change', actualizarVencimientoUI);
		radioVencSi.addEventListener('change', actualizarVencimientoUI);
		actualizarUI();
		actualizarVencimientoUI();
	}

	private ValidarModal(fechaOriginal: string): false | { fecha: string; vencimiento: string | null } {
		const radioFechaOriginal = document.getElementById('radioFechaOriginal') as HTMLInputElement;
		const radioOtraFecha = document.getElementById('radioOtraFecha') as HTMLInputElement;
		const inputFecha = document.getElementById('inputFecha') as HTMLInputElement;

		const radioVencNo = document.getElementById('radioVencNo') as HTMLInputElement;
		const radioVencSi = document.getElementById('radioVencSi') as HTMLInputElement;
		const inputVencimiento = document.getElementById('inputVencimiento') as HTMLInputElement;

		if (!radioFechaOriginal.checked && !radioOtraFecha.checked) {
			Swal.showValidationMessage('Debes seleccionar una opción de Fecha de emisión.');
			return false;
		}

		const hoy = moment().startOf('day');
		const fechaEmision = radioFechaOriginal.checked ? fechaOriginal : inputFecha.value;

		if (radioOtraFecha.checked) {
			if (!fechaEmision) {
				Swal.showValidationMessage('Selecciona una fecha de emisión.');
				return false;
			}
			const em = moment(fechaEmision, 'YYYY-MM-DD', true).startOf('day');
			if (!em.isValid()) { Swal.showValidationMessage('La fecha de emisión no es válida.'); return false; }
			if (em.isAfter(hoy)) { Swal.showValidationMessage('La fecha no puede ser futura.'); return false; }
		}

		let vencimiento: string | null = null;
		if (radioVencSi.checked) {
			vencimiento = inputVencimiento.value || null;
			if (!vencimiento) { Swal.showValidationMessage('Selecciona la fecha de vencimiento.'); return false; }
			const em = moment(fechaEmision, 'YYYY-MM-DD', true).startOf('day');
			const ve = moment(vencimiento, 'YYYY-MM-DD', true).startOf('day');
			if (!ve.isValid()) { Swal.showValidationMessage('La fecha de vencimiento no es válida.'); return false; }
			if (ve.isBefore(em)) { Swal.showValidationMessage('La fecha de vencimiento no puede ser menor a la fecha de emisión.'); return false; }
		}

		return { fecha: fechaEmision, vencimiento: radioVencNo.checked ? null : vencimiento };
	}

	sortDate(propA, propB, rowA, rowB) {
		if (new Date(propA))
			if (propA instanceof Date && propB instanceof Date) {
				if (propA < propB) return -1;
				if (propA > propB) return 1;
			}
	}

	getNullifyTypeName(event) {
		this.nombreTipoNota = event;
		this.ref.detectChanges();
	}

	resendDte(dte: DteEmitido) {
		this.loading = true;
		var request = new ActualizarEstadoSiiRequest();
		request.Dtes = [dte.dteId];
		request.usuarioId = this.tokenService.getUser().id;
		request.emisorId = this.emisorId;
		this.dteService.resendDte(request).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Estado Sii Actualizado",
					text: "El documento volverá a ser enviado al servicio de impuestos internos",
				});
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Actualizar Estado Sii",
					text: "No fue posible actualizar el estado sii del documento. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	toggleExpandRow(row) {
		this.tableRef.rowDetail.toggleExpandRow(row);
	}

	resendEmailSii(dte: DteEmitido) {
		this.loading = true;
		var request = new ReenvioEmailRequest();
		request.dteId = dte.dteId;
		request.usuarioId = this.tokenService.getUser().id;
		request.emisorId = this.emisorId;
		this.dteService.resendEmailSii(request).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Reenvio de Email Validación Sii",
					text: "La validación del documento desde el sii fue reenviada al email registrado en el servicio de impuestos internos",
				});
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al solicitar reenvio de correo de validación",
					text: "No fue posible solicitar el reenvio del correo de validación desde el sii. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}
	openDatePickerImportedDte(modalRef, month: boolean) {
		if (month) this.locale.format = "MM/YYYY";
		else this.locale.format = "DD/MM/YYYY";
		//this.dateConciliacion = null;
		this.dateConciliacion.startDate = moment().startOf("day");
		this.dateConciliacion.endDate = moment().subtract(1, "days").startOf("day");
		this.modalImportedDteSii = this.modalService.open(modalRef, {
			windowClass: "",
			size: "md",
			centered: true,
		});
	}

	//EXCEL EXPORT METHODS
	//Los metodos son DERCARGAR TODO, DESCARGAR LO FILTRADO(filtro aplicado en una sola hoja), DESCARGAR SELECCION
	// exportToExcel(conciliacionRequest: NgForm) {
	// 	if (conciliacionRequest.valid && this.validDate) {
	// 		this.loading = true;
	// 		this.getAllRowsByFilter(this.filter);
	// 	}

	// }

	// exportToExcel(dates: { fechaDesde: moment.Moment; fechaHasta: moment.Moment }) {
	// 	if (dates && dates.fechaDesde && dates.fechaHasta) {
	// 	  this.loading = true;
	// 	  //this.filter.fechaDesde = dates.fechaDesde.format('YYYY-MM-DD');
	// 	  //this.filter.fechaHasta = dates.fechaHasta.format('YYYY-MM-DD');
	// 	//   this.filter.fechaDesde = this.dateExportacion.startDate.format('YYYY-MM-DD');
	// 	//   this.filter.fechaHasta = this.dateExportacion.endDate.format('YYYY-MM-DD');
	// 	  this.getAllRowsByFilter(this.filter);
	// 	}
	//   }

	importDteSii(conciliacionRequest: NgForm) {
		if (conciliacionRequest.valid && this.validDate) {
			Swal.fire({
				title: "¿Desea importar dtes desde SII?",
				text: "Los dtes importados no tendrán opción de descargar archivos",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				confirmButtonText: "Si, importar",
				cancelButtonText: "Cancelar",
			}).then((result) => {
				if (result.isConfirmed) {
					this.loading = true;
					let conciliacion = new Conciliacion();
					conciliacion.emisorId = this.emisorId;
					conciliacion.usuarioId = this.usuarioId;
					conciliacion.sucursalId = this.sucursalId;
					conciliacion.dateString = moment(this.dateConciliacion.startDate).format("L");
					conciliacion.mensual = this.locale.format == "MM/YYYY" ? true : false;
					this.dteService.importDteSii(conciliacion).subscribe(
						(res) => {
							this.loading = false;
							this.ref.detectChanges();
							Swal.fire({
								icon: "success",
								title: "Importar Dtes desde Sii",
								showCloseButton: true,
								html: "<div style='text-align:center;'><p>" + res.message + "</p></div>",
							});
							this.modalImportedDteSii.close();
							this.setPage({ offset: 0 });
						},
						(err) => {
							this.loading = false;
							this.ref.detectChanges();
							this.currentSwal.icon = "error";
							this.currentSwal.title = "Error al Importar Dtes desde Sii";
							this.currentSwal.text = "No es posible realizar la importación de dtes desde el sii. Intente mas tarde. " + this.utilities.setErrorMessageFromArray(err.error);
							this.currentSwal.fire();
						}
					);
				}
			});
		}
	}

	openImportBoletasSiiModal(modalRef) {
		this.validDateImportacionBoletas = true;
		this.dateImportacionBoletas = {
			startDate: moment().startOf("month"),
			endDate: moment().startOf("month"),
		};
		this.refreshImportBoletasSiiStatus();
		this.modalImportBoletasSii = this.modalService.open(modalRef, {
			windowClass: "",
			size: "md",
			centered: true,
		});
	}

	refreshImportBoletasSiiStatus() {
		if (!this.dateImportacionBoletas || !this.dateImportacionBoletas.startDate || !this.validDateImportacionBoletas) return;
		const periodo = moment(this.dateImportacionBoletas.startDate);
		const requestId = ++this.importacionBoletasStatusRequestId;
		this.importacionBoletasLoading = true;
		this.importacionBoletasStatus = null;
		this.dteService.getImportBoletasSiiStatus(this.emisorId, periodo.month() + 1, periodo.year()).subscribe(
			(res) => {
				if (requestId !== this.importacionBoletasStatusRequestId) return;
				this.importacionBoletasStatus = res.data;
				this.importacionBoletasLoading = false;
				this.ref.detectChanges();
			},
			() => {
				if (requestId !== this.importacionBoletasStatusRequestId) return;
				this.importacionBoletasLoading = false;
				this.ref.detectChanges();
			}
		);
	}

	confirmImportBoletasSii(form: NgForm) {
		if (!form.valid || !this.validDateImportacionBoletas || this.importacionBoletasBloqueada()) return;
		Swal.fire({
			title: "¿Confirmas la importación de boletas desde el SII?",
			text: "Por disposición del SII, SimpleFactura permite ejecutar esta importación una vez al día por emisor, ambiente y período mensual. Al completar correctamente esta operación, no podrás volver a importar el mismo período durante el día de hoy en el ambiente actual.",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Sí, importar",
			cancelButtonText: "Cancelar",
		}).then((result) => {
			if (result.isConfirmed) this.importBoletasSii();
		});
	}

	importBoletasSii() {
		this.loading = true;
		let conciliacion = new Conciliacion();
		conciliacion.emisorId = this.emisorId;
		conciliacion.usuarioId = this.usuarioId;
		conciliacion.sucursalId = this.sucursalId;
		conciliacion.mensual = true;
		conciliacion.dateString = moment(this.dateImportacionBoletas.startDate).format("MM/YYYY");

		this.dteService.importBoletasSii(conciliacion).subscribe(
			(res) => {
				this.loading = false;
				this.importacionBoletasStatus = {
					puedeImportar: false,
					estado: "Exitosa",
					ambiente: this.importacionBoletasStatus ? this.importacionBoletasStatus.ambiente : "",
					modalidad: "Mensual",
					fechaUltimaImportacion: moment().toISOString(),
					totalBoletasReporte: res.data.totalBoletasReporte,
					totalBoletasPeriodo: res.data.totalBoletasPeriodo,
					totalBoletasExistentes: res.data.totalBoletasExistentes,
					totalBoletasNuevas: res.data.totalBoletasNuevas,
					mensaje: "La importación de boletas del SII para este período ya fue realizada hoy.",
				};
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Importación de boletas desde el SII",
					html: this.buildResumenImportacionBoletas(res.data),
				}).then(() => {
					this.modalImportBoletasSii.close();
					this.setPage({ offset: 0 });
				});
			},
			(err) => {
				this.loading = false;
				this.ref.detectChanges();
				if (err.status === 409) {
					this.refreshImportBoletasSiiStatus();
					Swal.fire({
						icon: "warning",
						title: "Importación no disponible",
						text: this.utilities.setErrorMessageFromArray(err.error),
					});
					return;
				}
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error al importar boletas desde Sii";
				this.currentSwal.text = "La última importación no pudo completarse. Puedes volver a intentarlo. " + this.utilities.setErrorMessageFromArray(err.error);
				this.currentSwal.fire();
			}
		);
	}

	detectChangeDateImportacionBoletas(event) {
		this.validDateImportacionBoletas = true;
		if (event.startDate != null) {
			this.dateImportacionBoletas = event;
			this.refreshImportBoletasSiiStatus();
			return;
		}
		if (event.target != null && event.target.value != null) {
			this.validDateImportacionBoletas = moment(event.target.value, this.localeBoletas.format, true).isValid();
			if (this.validDateImportacionBoletas) {
				this.dateImportacionBoletas = {
					startDate: moment(event.target.value, this.localeBoletas.format),
				};
				this.refreshImportBoletasSiiStatus();
			}
		}
	}

	importacionBoletasBloqueada(): boolean {
		return this.importacionBoletasStatus &&
			!this.importacionBoletasStatus.puedeImportar &&
			(this.importacionBoletasStatus.estado === "Exitosa" || this.importacionBoletasStatus.estado === "EnProceso");
	}

	formatImportacionBoletasFecha(value?: string): string {
		return value ? moment(value).format("DD/MM/YYYY HH:mm") : "";
	}

	formatImportacionBoletasPeriodo(): string {
		return this.dateImportacionBoletas && this.dateImportacionBoletas.startDate
			? moment(this.dateImportacionBoletas.startDate).format("MM/YYYY")
			: "";
	}

	private buildResumenImportacionBoletas(totales: ImportacionBoletasSiiTotales): string {
		return "<div style='text-align:left;'>" +
			"<p>Boletas recibidas en el reporte: " + totales.totalBoletasReporte + "</p>" +
			"<p>Boletas pertenecientes al período: " + totales.totalBoletasPeriodo + "</p>" +
			"<p>Boletas existentes: " + totales.totalBoletasExistentes + "</p>" +
			"<p>Boletas nuevas importadas: " + totales.totalBoletasNuevas + "</p>" +
			"</div>";
	}

	detectChangeDate(event) {
		this.validDate = true;
		let fromDate: any;
		if (event.startDate != null) {
			this.dateConciliacion = event;
		} else {
			if (event.target != null && event.target.value != null) {
				this.validDate = moment(event.target.value, this.locale.format, true).isValid();
				if (this.validDate) {
					fromDate = new Object();
					fromDate.startDate = moment(event.target.value, this.locale.format);
					this.dateConciliacion = fromDate;
				}
			}
		}
	}

	reuse(dte: DteEmitido) {
		this.loading = true;
		this.dteService.reuse(dte.dteId).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Reutilización de Folio",
					text: res.message,
				});
				this.setPage({ offset: 0 });
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Solicitar Reutilización de Folio",
					text: "No fue posible solicitar la reutilización de folio. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	tryMassiveRouseConfirm() {
		if (this.selected.length > 0) {
			var allValid = this.selected.every((x) => x.estadoSii === 5 || x.estadoSii == 10);
			if (!allValid) {
				Swal.fire({
					icon: "error",
					title: "Error de Selección",
					text: "Solo se pueden reutilizar folios de documentos que estén rechazados por el SII",
				});
				return;
			}
			Swal.fire({
				icon: "info",
				title: "Reutilizar folios",
				text: "¿Está seguro de reutilizar los folios de los documentos seleccionados?",
				confirmButtonText: "Continuar",
				confirmButtonColor: "#1BC5BD",
				showCancelButton: true,
				cancelButtonText: "Cancelar",
				cancelButtonColor: "#F64E60",
			}).then((res) => {
				if (res.isConfirmed) {
					this.massiveReuse();
				} else {
					return;
				}
			});
		} else {
			Swal.fire({
				icon: "error",
				title: "Error de Selección",
				text: "No se ha seleccionado ningún documento válido para reutilizar.\nFavor seleccionar un documento con la columna selectora.",
			});
		}
	}
	massiveReuse() {
		var ids: string[] = [];
		this.selected.forEach((dte) => {
			ids.push(dte.dteId);
		});
		this.loading = true;
		var request = new ReutilizacionMasivaRequest();
		request.ids = ids;
		request.usuarioId = this.usuarioId;
		this.dteService.massivereuse(request).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Reutilización de Folios Masivo",
					text: res.message,
				});
				this.setPage({ offset: 0 });
				this.selected = [];
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error al Solicitar Reutilización de Folios Masivo",
					text: "No fue posible solicitar la reutilización de folios masivo. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}
	downloadMassiveFile(dte: DteEmitido) {
		var valid = dte.importacionMasivaId ? true : false;
		if (valid) {
			this.loading = true;
			this.facturadorService
				.getFile(dte.importacionMasivaId)
				.subscribe(
					(res) => {
						let uint8Array = res.data as Uint8Array;
						let b64Response = res.data;
						//obtained  8bit array from response that need to be transformed into a Blob
						try {
							const blobCsv = this.utilities.convertB64ToBlob(b64Response, "text/csv");
							FileSaver.saveAs(blobCsv, "lista_de_facturas.csv");
						} catch (error) {
							this.setSwalAndFire(this.currentSwal, "error", "Error en Archivo", "No fue posible obtener el archivo CSV, favor contactar al administrador\n" + error);
						}
					},
					(error) => {
						this.setSwalAndFire(this.currentSwal, "error", "Error", "Error al obtener el archivo. Intente más tarde." + this.utilities.setErrorMessageFromArray(error.error));
					}
				)
				.add(() => {
					this.loading = false;
					this.ref.detectChanges();
				});
		} else {
			Swal.fire({
				icon: "error",
				title: "Error al Obtener archivo",
				text: "El documento seleccionado no posee un archivo de importación masiva",
			});
		}
	}

	getEmisoresFullList() {
		this.emisorService.getData().subscribe(
			(result) => {
				let emisores = result.data;
				this.empresasSource = emisores;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en emisores",
					text: "No fue posible obtener la lista de emisores completa, tiene disponible solamente los emisores ya presentes en el selector de empresas." + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	openExportModal() {
		const modalRef = this.modalService.open(ExportModalComponent, {
			size: "md",
			centered: true,
		});
		modalRef.componentInstance.locale = this.locale;
		modalRef.componentInstance.type = 33;
		modalRef.componentInstance.filter = { ...this.filter };
		modalRef.componentInstance.useGridFilters = true;
		modalRef.componentInstance.getDataFunction = this.getDataToExport.bind(this);
		modalRef.componentInstance.getSummaryFunction = this.getExportSummary.bind(this);
		modalRef.componentInstance.exportData.subscribe((data) => {
			this.loading = data;
			this.ref.detectChanges();
		});
	}

	getDataToExport(filter: DteFilter): Observable<DteEmitido[]> {
		return this.dteService.getDataToExport(filter);
	}

	getExportSummary(filter: DteFilter): Observable<Response<DteExportSummary>> {
		return this.dteService.getExportSummary(filter);
	}
	public isFacturaOrBoleta(codigoSii?: number): boolean {
		if (!codigoSii) {
			if (!this.tipoDteSource || !Array.isArray(this.tipoDteSource)) return false;
			return this.tipoDteSource.some((tipo) => [33, 34, 39, 41].includes(tipo.codigosii));
		}

		return [33, 34, 39, 41].includes(codigoSii);
	}
	private validatePaykuAdicional(): void {
		if (!this.emisorId) {
			this.tienePayku = false;
			this.showMarcarPagadoButton = false;
			return;
		}
		this.paykuService.validarAdicionalPaykuPorEmisor(this.emisorId).subscribe({
			next: (response) => {
				this.tienePayku = response.data?.habilitado || false;
				this.showMarcarPagadoButton = response.data?.habilitado || false;
				this.ref.detectChanges();
			},
			error: (error) => {
				console.error('Error validando Payku adicional:', error);
				this.tienePayku = false;
				this.showMarcarPagadoButton = false;
				this.ref.detectChanges();
			}
		});
	}

	get permisoPayku(): boolean {
		return this.permissions.getPermission("83-20").asignado;
	}

	confirmarCambioEstado(row: DteEmitido, nuevoEstado: "pagado" | "pendiente") {
		const esPagado = nuevoEstado === "pagado";
		const titulo = esPagado ? "Marcar como Pagado" : "Marcar como Pendiente";
		const texto = esPagado ? `¿Desea marcar el documento folio ${row.folio} como PAGADO?` : `¿Desea marcar el documento folio ${row.folio} como PENDIENTE?`;
		const confirmText = esPagado ? "Marcar Pagado" : "Marcar Pendiente";

		Swal.fire({
			icon: "question",
			title: titulo,
			text: texto,
			confirmButtonText: confirmText,
			confirmButtonColor: "#1BC5BD",
			showCancelButton: true,
			cancelButtonText: "Cancelar",
			cancelButtonColor: "#F64E60",
		}).then((res) => {
			if (res.isConfirmed) {
				this.cambiarEstadoPago(row, nuevoEstado);
			}
		});
	}

	cambiarEstadoPago(row: DteEmitido, nuevoEstado: "pagado" | "pendiente") {
		this.loading = true;

		const request: MarcarPagadoOPendiente = {
			dteId: row.dteId,
			usuarioId: this.usuarioId,
			emisorId: this.emisorId,
		};

		this.dteService.marcarEstadoPago(request).subscribe({
			next: (resp) => {
				this.loading = false;
				const ok = resp?.data === true;
				if (ok) {
					Swal.fire({
						icon: "success",
						title: "Operación Exitosa",
						text: `El documento de folio ${row.folio} cambio su estado a ${nuevoEstado} correctamente.`,
					}).then((result) => {
						if (result.isConfirmed || result.isDismissed) {
							window.location.reload();
						}
					});
					this.ref.detectChanges();
				} else {
					Swal.fire({
						icon: "error",
						title: "Error",
						text: resp?.message || "No fue posible completar la operación.",
					});
					this.ref.detectChanges();
				}
			},
			error: (error) => {
				this.loading = false;
				this.ref.detectChanges();

				Swal.fire({
					icon: "error",
					title: "Error al cambiar estado",
					text: "No fue posible cambiar el estado del documento. " + this.utilities.setErrorMessageFromArray(error?.error),
				});
			},
		});
	}
}
